<template>
  <div class="cost-diff-handle-page">
    <div class="filter-area">
      <el-form :inline="true" :label-width="'80px'" class="filter-form">
        <el-form-item label="账单周期">
          <el-date-picker
            v-model="filterForm.billCycle"
            type="month"
            placeholder="选择月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            style="width: 150px;"
          />
        </el-form-item>
        <el-form-item label="运单号">
          <el-input v-model="filterForm.expressNo" placeholder="请输入运单号" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="成本差异单号">
          <el-input v-model="filterForm.diffBillNo" placeholder="请输入差异单号" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="处理方">
          <el-select v-model="filterForm.handlerRole" multiple placeholder="请选择处理方" style="width: 200px;">
            <el-option label="物流商" value="物流商" />
            <el-option label="财务" value="财务" />
            <el-option label="IT" value="IT" />
            <el-option label="配送组" value="配送组" />
            <el-option label="KA" value="KA" />
            <el-option label="运营" value="运营" />
          </el-select>
        </el-form-item>
        <el-form-item label="差异原因">
          <el-select v-model="filterForm.diffReason" multiple placeholder="请选择差异原因" style="width: 200px;">
            <el-option v-for="reason in diffReasons" :key="reason" :label="reason" :value="reason" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="filterForm.status" multiple placeholder="请选择处理状态" style="width: 200px;">
            <el-option label="待处理" value="待处理" />
            <el-option label="已处理" value="已处理" />
            <el-option label="已驳回" value="已驳回" />
            <el-option label="已关闭" value="已关闭" />
          </el-select>
        </el-form-item>
        <el-form-item label="物流商">
          <el-select v-model="filterForm.transportName" multiple placeholder="请选择物流商" style="width: 200px;">
            <el-option label="顺丰快递" value="顺丰快递" />
            <el-option label="圆通快递" value="圆通快递" />
            <el-option label="中通快递" value="中通快递" />
          </el-select>
        </el-form-item>
        <el-form-item label="抄送状态">
          <el-select v-model="filterForm.ccStatus" multiple placeholder="请选择抄送状态" style="width: 200px;">
            <el-option label="全部" value="" />
            <el-option label="待反馈" value="待反馈" />
            <el-option label="已反馈" value="已反馈" />
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="filterForm.companyName" placeholder="请输入公司名称" style="width: 200px;" @keyup.enter="handleSearch" />
        </el-form-item>
        <div class="filter-actions">
          <el-button icon="el-icon-setting" class="setting-btn" @click="showSettingsDialog = true"></el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </div>
      </el-form>
    </div>

    <div class="view-tabs-bar">
      <div class="tabs-wrapper">
        <el-radio-group v-model="currentView" @change="handleViewChange">
          <el-radio-button v-if="showMyTask" label="myTask">我的待办</el-radio-button>
          <el-radio-button v-if="showMyAudit" label="myAudit">我审核的</el-radio-button>
          <el-radio-button v-if="showMyCC" label="myCC">我抄送的</el-radio-button>
          <el-radio-button label="all">全部</el-radio-button>
        </el-radio-group>
      </div>
      <div class="buttons-wrapper">
        <el-button type="info" @click="openSyncDialog">同步物流商</el-button>
        <el-button icon="el-icon-document" @click="goToImportExportResult">导入导出结果</el-button>
        <el-button v-if="canImport" type="primary" icon="el-icon-upload2" @click="showImportDialog = true">导入</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport" :loading="exportLoading">导出</el-button>
        <el-button icon="el-icon-setting" @click="showSettingsDialog" class="settings-btn"></el-button>
      </div>
    </div>

    <div class="diff-list-area">
      <el-table
        :data="filteredDiffList"
        border
        style="width: 100%"
        :fit="true"
        max-height="580px"
      >
        <el-table-column
          prop="diffBillNo"
          label="成本差异单号"
          min-width="160"
          sortable
        />
        <el-table-column
          prop="billCycle"
          label="账单周期"
          width="100"
          sortable
        />
        <el-table-column
          prop="expressNo"
          label="运单号"
          min-width="180"
        />
        <el-table-column
          prop="transportName"
          label="物流商"
          width="120"
        />
        <el-table-column
          prop="diffReason"
          label="差异原因"
          min-width="120"
        />
        <el-table-column
          prop="handlerRole"
          label="处理方"
          width="90"
        />
        <el-table-column
          prop="status"
          label="处理状态"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="checkBrand"
          label="核对品牌"
          width="120"
        />
        <el-table-column
          prop="finalBrand"
          label="最终品牌"
          width="120"
        />
        
        <el-table-column
          v-if="showHandlerFeedbackColumns"
          prop="handlerName"
          label="处理人"
          width="100"
        />
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="150"
          sortable
        />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="150"
          sortable
        />
        <el-table-column
          v-if="showAuditColumns"
          prop="rejectPerson"
          label="驳回人"
          width="100"
        />
        <el-table-column
          v-if="showAuditColumns"
          prop="rejectTime"
          label="驳回时间"
          width="150"
        />
        <el-table-column
          v-if="showRejectReasonColumn"
          prop="rejectReason"
          label="驳回原因"
          width="150"
        />
        <el-table-column
          v-if="showAuditColumns"
          prop="auditPerson"
          label="审核人"
          width="100"
        />
        <el-table-column
          v-if="showAuditColumns"
          prop="auditTime"
          label="审核时间"
          width="150"
        />
        <el-table-column
          v-if="showCCColumns"
          prop="ccPersons"
          label="抄送人"
          width="120"
        />
        <el-table-column
          v-if="showCCColumns"
          prop="ccTime"
          label="抄送时间"
          width="150"
        />
        <el-table-column
          prop="forwardReason"
          label="转发原因"
          width="150"
        />
        
        <el-table-column
          v-if="showFinanceColumns"
          prop="billDate"
          label="账单日期"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzBrand"
          label="BZ_品牌"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzWarehouseName"
          label="BZ_仓库名称"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzShopName"
          label="BZ_店铺名称"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzTransportName"
          label="BZ_物流商名称"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportCode"
          label="物流商编码"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzDeliveryTime"
          label="BZ_发货时间"
          width="140"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzDataSouring"
          label="BZ_DataSouring"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzOrderType"
          label="BZ_订单类型"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzPreOrderNo"
          label="BZ_前置单据号"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzShopCostCenter"
          label="BZ_店铺成本中心"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzParkName"
          label="BZ_园区名称"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzParkCostCenter"
          label="BZ_园区成本中心"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzWeight"
          label="BZ_重量"
          width="80"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzOrderAmount"
          label="BZ_订单金额"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportMonthlyAccount"
          label="物流商月结账号"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzMonthlyAccount"
          label="BZ_系统月结账号"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportProductTypeName"
          label="物流商产品类型名称"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzProductTypeName"
          label="BZ_系统产品类型名称"
          width="120"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportDestProvince"
          label="物流商目的省"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzDestProvince"
          label="BZ_系统目的省"
          width="100"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportBillingWeight"
          label="物流商计费重量"
          width="110"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzBillingWeight"
          label="BZ_系统计费重量"
          width="110"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="transportFirstWeightPrice"
          label="物流商首重价格"
          width="110"
        />
        <el-table-column
          v-if="showFinanceColumns"
          prop="bzFirstWeightPrice"
          label="BZ_系统首重价格"
          width="110"
        />
        <el-table-column
          prop="transportContinueWeightPrice"
          label="物流商续重价格"
          width="110"
        />
        <el-table-column
          prop="bzContinueWeightPrice"
          label="BZ_系统续重价格"
          width="110"
        />
        <el-table-column
          prop="transportStandardFreight"
          label="物流商标准运费"
          width="110"
        />
        <el-table-column
          prop="bzStandardFreight"
          label="BZ_系统标准运费"
          width="110"
        />
        <el-table-column
          prop="standardFreightDiff"
          label="标准运费差异"
          width="100"
        />
        <el-table-column
          prop="transportDiscountedFreight"
          label="物流商折后运费"
          width="110"
        />
        <el-table-column
          prop="bzDiscountedFreight"
          label="BZ_系统折后运费"
          width="110"
        />
        <el-table-column
          prop="discountedFreightDiff"
          label="折后运费差异"
          width="100"
        />
        <el-table-column
          prop="transportTotalFee"
          label="物流商总费用"
          width="100"
        />
        <el-table-column
          prop="bzTotalFee"
          label="BZ_系统总费用"
          width="100"
        />
        <el-table-column
          prop="totalFeeDiff"
          label="总费用差异"
          width="100"
        />
        <el-table-column
          prop="bzLength"
          label="BZ_系统长"
          width="80"
        />
        <el-table-column
          prop="bzWidth"
          label="BZ_系统宽"
          width="80"
        />
        <el-table-column
          prop="bzHeight"
          label="BZ_系统高"
          width="80"
        />
        <el-table-column
          prop="bzVolume"
          label="BZ_系统体积"
          width="80"
        />
        <el-table-column
          prop="bzVolumeWeight"
          label="BZ_系统体积重"
          width="100"
        />
        <el-table-column
          prop="bzDiscountRate"
          label="BZ_系统折扣率"
          width="100"
        />
        <el-table-column
          prop="bzInsuranceFee"
          label="BZ_系统保价费"
          width="100"
        />
        <el-table-column
          prop="bzFuelSurcharge"
          label="BZ_系统燃油附加费"
          width="120"
        />
        <el-table-column
          prop="bzPickupFee"
          label="BZ_系统委托取件费"
          width="120"
        />
        <el-table-column
          prop="bzSpecialServiceFee"
          label="BZ_系统特殊服务费"
          width="120"
        />
        <el-table-column
          prop="bzSuppliesCode"
          label="BZ_系统耗材编码"
          width="120"
        />
        <el-table-column
          prop="bzPhysicalWarehouseName"
          label="BZ_系统物理仓名称"
          width="130"
        />
        <el-table-column
          prop="bzPhysicalShopName"
          label="BZ_系统物理店名称"
          width="130"
        />
        <el-table-column
          prop="paymentOutlet"
          label="付款网点"
          width="100"
        />
        <el-table-column
          prop="handlerPerson"
          label="经手人"
          width="80"
        />
        <el-table-column
          prop="tax"
          label="税金"
          width="80"
        />
        <el-table-column
          prop="claimFee"
          label="理赔费用"
          width="100"
        />
        <el-table-column
          prop="specialWarehouseServiceFee"
          label="特殊仓库服务费"
          width="120"
        />
        <el-table-column
          prop="packagingServiceFee"
          label="包装服务费"
          width="100"
        />
        <el-table-column
          prop="customerUpstairsFee"
          label="客户上楼费"
          width="100"
        />
        <el-table-column
          prop="peakSeasonSurcharge"
          label="高峰期附加费"
          width="110"
        />
        <el-table-column
          prop="insuranceFee"
          label="保价费"
          width="80"
        />
        <el-table-column
          prop="onTimeBao"
          label="准时宝"
          width="80"
        />
        <el-table-column
          prop="resourceAdjustmentFee"
          label="资源调节费"
          width="100"
        />
        <el-table-column
          prop="keyAuthenticationFee"
          label="密钥认证费"
          width="100"
        />
        <el-table-column
          prop="signReturnFee"
          label="签单返还费"
          width="100"
        />
        <el-table-column
          prop="fengchaoDiscountFee"
          label="丰巢寄件优惠费"
          width="120"
        />
        <el-table-column
          prop="receivingMicroDeliveryFee"
          label="收件微派费"
          width="100"
        />
        <el-table-column
          prop="fuelSurcharge"
          label="燃油附加费"
          width="100"
        />
        <el-table-column
          prop="pickupFee"
          label="委托取件费"
          width="100"
        />
        <el-table-column
          prop="oversizedFee"
          label="超长超重费"
          width="100"
        />
        <el-table-column
          prop="returnFee"
          label="退回费"
          width="80"
        />
        <el-table-column
          prop="springFestivalService"
          label="春节不打烊"
          width="100"
        />
        <el-table-column
          prop="specialAreaSurcharge"
          label="特殊地区加价费用"
          width="120"
        />
        <el-table-column
          prop="agreementClause11"
          label="协议条款11"
          width="100"
        />
        <el-table-column
          prop="agreementClause12"
          label="协议条款12"
          width="100"
        />
        <el-table-column
          prop="agreementClause618"
          label="协议条款618"
          width="100"
        />
        <el-table-column
          prop="otherFee"
          label="其他费"
          width="80"
        />
        <el-table-column
          prop="discountAmount"
          label="折扣金额"
          width="100"
        />
        <el-table-column
          prop="paymentMethod"
          label="付款方式"
          width="100"
        />
        <el-table-column
          prop="billingWeight"
          label="计费重量"
          width="100"
        />
        <el-table-column
          prop="oppositeCompanyName"
          label="对方公司名称"
          width="120"
        />
        <el-table-column
          prop="deliveryStaffNo"
          label="派件员工号"
          width="100"
        />
        <el-table-column
          prop="senderCompanyName"
          label="寄件公司名称"
          width="120"
        />
        <el-table-column
          prop="senderName"
          label="寄件人"
          width="80"
        />
        <el-table-column
          prop="senderCompanyPhone"
          label="寄件公司电话"
          width="120"
        />
        <el-table-column
          prop="finalStandardFreight"
          label="最终标准运费"
          width="110"
        />
        <el-table-column
          prop="finalDiscountedFreight"
          label="最终折后运费"
          width="110"
        />
        <el-table-column
          prop="finalTotalFee"
          label="最终总费用"
          width="100"
        />
        <el-table-column
          prop="checkBrand"
          label="核对后品牌"
          width="120"
        />
        <el-table-column
          prop="checkDiscount"
          label="核对后折扣/促销"
          width="140"
        />
        <el-table-column
          prop="checkAgreementClause11"
          label="核对后协议条款11"
          width="130"
        />
        <el-table-column
          prop="checkAgreementClause12"
          label="核对后协议条款12"
          width="130"
        />
        <el-table-column
          prop="checkAgreementClause618"
          label="核对后协议条款618"
          width="140"
        />
        <el-table-column
          prop="checkReturnFee"
          label="核对后退回费"
          width="120"
        />
        <el-table-column
          prop="checkSpringFestivalService"
          label="核对后春节不打烊"
          width="140"
        />
        <el-table-column
          prop="checkSpecialAreaSurcharge"
          label="核对后特殊地区加价费用"
          width="160"
        />
        <el-table-column
          prop="checkOtherFee"
          label="核对后其他费用"
          width="120"
        />
        <el-table-column
          prop="checkPayableAmountFormula"
          label="核对后应付金额计算公式"
          width="180"
        />
        <el-table-column
          prop="checkInsuranceFee"
          label="核对后保价费"
          width="120"
        />
        <el-table-column
          prop="finalRebate"
          label="最终返利"
          width="100"
        />
        <el-table-column
          prop="finalActualWeight"
          label="最终实际重量"
          width="120"
        />
        <el-table-column
          prop="finalDiscount"
          label="最终折扣/促销"
          width="140"
        />
        <el-table-column
          prop="finalAgreementClause11"
          label="最终协议条款11"
          width="130"
        />
        <el-table-column
          prop="finalAgreementClause12"
          label="最终协议条款12"
          width="130"
        />
        <el-table-column
          prop="finalAgreementClause618"
          label="最终协议条款618"
          width="140"
        />
        <el-table-column
          prop="finalReturnFee"
          label="最终退回费"
          width="120"
        />
        <el-table-column
          prop="finalSpringFestivalService"
          label="最终春节不打烊"
          width="140"
        />
        <el-table-column
          prop="finalSpecialAreaSurcharge"
          label="最终特殊地区加价费用"
          width="160"
        />
        <el-table-column
          prop="finalOtherFee"
          label="最终其他费用"
          width="120"
        />
        <el-table-column
          prop="finalInterceptFlag"
          label="最终拦截标识"
          width="120"
        />
        <el-table-column
          prop="finalPayableAmountFormula"
          label="最终应付金额计算公式"
          width="180"
        />
        <el-table-column
          prop="finalInsuranceFee"
          label="最终保价费"
          width="120"
        />
        <el-table-column
          prop="finalBrand"
          label="最终品牌"
          width="120"
        />
        <el-table-column
          prop="signTime"
          label="签收时间"
          width="140"
        />
        <el-table-column
          prop="returnOrderNo"
          label="退回件关联运单号"
          width="140"
        />
        <el-table-column
          prop="extraField1"
          label="附加字段1"
          width="100"
        />
        <el-table-column
          prop="extraField2"
          label="附加字段2"
          width="100"
        />
        <el-table-column
          prop="extraField3"
          label="附加字段3"
          width="100"
        />
        <el-table-column
          prop="signer"
          label="签收人"
          width="80"
        />
        <el-table-column
          prop="senderCompanyAddress"
          label="寄件公司地址"
          width="150"
        />
        <el-table-column
          prop="receiverStaffNo"
          label="收件人工号"
          width="100"
        />
        <el-table-column
          prop="receiverAddress"
          label="收件地址"
          width="150"
        />
        <el-table-column
          prop="cargoContent"
          label="托寄物内容"
          width="120"
        />
        <el-table-column
          prop="cargoQuantity"
          label="托寄物数量"
          width="100"
        />
        <el-table-column
          prop="pieceCount"
          label="件数"
          width="80"
        />
        <el-table-column
          prop="declaredValue"
          label="声明价值"
          width="100"
        />
        <el-table-column
          prop="actualWeight"
          label="实际重量"
          width="100"
        />
        <el-table-column
          prop="length"
          label="长"
          width="80"
        />
        <el-table-column
          prop="width"
          label="宽"
          width="80"
        />
        <el-table-column
          prop="height"
          label="高"
          width="80"
        />
        <el-table-column
          prop="volume"
          label="体积"
          width="80"
        />
        <el-table-column
          prop="remark"
          label="备注"
          width="120"
        />
        <el-table-column
          prop="expressContent"
          label="快件内容"
          width="100"
        />
        <el-table-column
          prop="originProvince"
          label="始发地(省名)"
          width="100"
        />
        <el-table-column
          prop="sendTime"
          label="寄件时间"
          width="140"
        />
        <el-table-column
          prop="deliveryOutlet"
          label="派件网点"
          width="100"
        />
        <el-table-column
          prop="sendOutlet"
          label="寄件网点"
          width="100"
        />
        <el-table-column
          prop="lightThrowFactor"
          label="轻抛系数"
          width="100"
        />
        <el-table-column
          prop="billingWeightFormula"
          label="计费重量计算公式（文字形式）"
          width="150"
        />
        <el-table-column
          prop="payableAmountFormula"
          label="应付金额计算公式"
          width="120"
        />
        <el-table-column
          prop="returnBatchNo"
          label="退货批次号"
          width="120"
        />
        <el-table-column
          prop="diffAdjustReason"
          label="差异调整原因"
          width="120"
        />
        <el-table-column
          prop="areaType"
          label="区域类型"
          width="100"
        />
        <el-table-column
          prop="bzOriginProvince"
          label="BZ_系统始发省"
          width="110"
        />
        <el-table-column
          prop="bzSendCity"
          label="BZ_系统寄件市"
          width="110"
        />
        <el-table-column
          prop="bzReceiveCity"
          label="BZ_系统到件市"
          width="110"
        />
        <el-table-column
          prop="receiverCompanyName"
          label="到方客户名称"
          width="120"
        />
        <el-table-column
          prop="receiverCompanyPhone"
          label="到方客户电话"
          width="120"
        />
        <el-table-column
          prop="receiverName"
          label="收件人"
          width="80"
        />
        <el-table-column
          prop="sendArea"
          label="寄件地区"
          width="100"
        />
        <el-table-column
          prop="receiveArea"
          label="到件地区"
          width="100"
        />
        <el-table-column
          prop="returnReceiptNo"
          label="回单单号"
          width="120"
        />
        <el-table-column
          prop="firstWeightPrice"
          label="首重单价"
          width="100"
        />
        <el-table-column
          prop="continueWeightPrice"
          label="续重单价"
          width="100"
        />
        <el-table-column
          prop="interceptFlag"
          label="拦截标识"
          width="100"
        />
        <el-table-column
          prop="childNo"
          label="子单号"
          width="120"
        />
        <el-table-column
          prop="backup1"
          label="备用1"
          width="80"
        />
        <el-table-column
          prop="backup2"
          label="备用2"
          width="80"
        />
        <el-table-column
          prop="backup3"
          label="备用3"
          width="80"
        />
        <el-table-column
          prop="backup4"
          label="备用4"
          width="80"
        />
        <el-table-column
          prop="backup5"
          label="备用5"
          width="80"
        />
        <el-table-column
          prop="backup6"
          label="备用6"
          width="80"
        />
        <el-table-column
          prop="backup7"
          label="备用7"
          width="80"
        />
        <el-table-column
          prop="backup8"
          label="备用8"
          width="80"
        />
        <el-table-column
          prop="backup9"
          label="备用9"
          width="80"
        />
        <el-table-column
          prop="backup10"
          label="备用10"
          width="80"
        />
        <el-table-column
          prop="updatePerson"
          label="更新人"
          width="80"
        />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="140"
        />
        <el-table-column
          prop="exceptionReason"
          label="异常原因(详情)"
          width="120"
        />
        <el-table-column
          prop="companyName"
          label="公司名称"
          width="120"
        />
        <el-table-column
          prop="billStatus"
          label="账单状态"
          width="100"
        />
        <el-table-column
          prop="billBatchNo"
          label="账单批次号"
          width="120"
        />
        <el-table-column
          prop="monthlyUsageDesc"
          label="月结使用说明"
          width="120"
        />
        <el-table-column
          prop="monthlyBusiness"
          label="月结应用业务"
          width="120"
        />
        <el-table-column
          prop="monthlySettlementAccount"
          label="月结结算账号"
          width="120"
        />
        <el-table-column
          prop="rebate"
          label="返利"
          width="80"
        />
        <el-table-column
          prop="bzRebate"
          label="bz_返利"
          width="80"
        />
        <el-table-column
          prop="rebateDiff"
          label="返利差异"
          width="100"
        />
        <el-table-column
          prop="checkResult"
          label="核对结果"
          width="100"
        />
        <el-table-column
          prop="checkBillingWeight"
          label="核对后计费重量"
          width="120"
        />
        <el-table-column
          prop="checkSenderProvince"
          label="核对后寄件省"
          width="110"
        />
        <el-table-column
          prop="checkSenderCity"
          label="核对后寄件市"
          width="110"
        />
        <el-table-column
          prop="checkSenderDistrict"
          label="核对后寄件区"
          width="110"
        />
        <el-table-column
          prop="checkReceiverProvince"
          label="核对后收件省"
          width="110"
        />
        <el-table-column
          prop="checkReceiverCity"
          label="核对后收件市"
          width="110"
        />
        <el-table-column
          prop="checkReceiverDistrict"
          label="核对后收件区"
          width="110"
        />
        <el-table-column
          prop="checkFirstWeightPrice"
          label="核对后首重单价"
          width="120"
        />
        <el-table-column
          prop="checkContinueWeightPrice"
          label="核对后续重单价"
          width="120"
        />
        <el-table-column
          prop="checkInterceptFlag"
          label="核对后拦截标识"
          width="120"
        />
        <el-table-column
          prop="checkLightThrowFactor"
          label="核对后轻抛系数"
          width="120"
        />
        <el-table-column
          prop="checkActualWeight"
          label="核对后实际重量"
          width="120"
        />
        <el-table-column
          prop="checkProductType"
          label="核对后产品类型"
          width="120"
        />
        <el-table-column
          prop="checkStandardFreight"
          label="核对后标准运费"
          width="120"
        />
        <el-table-column
          prop="checkDiscountedFreight"
          label="核对后折后运费"
          width="120"
        />
        <el-table-column
          prop="checkDeclaredValue"
          label="核对后声明价值"
          width="120"
        />
        <el-table-column
          prop="checkVolume"
          label="核对后体积"
          width="100"
        />
        <el-table-column
          prop="checkLength"
          label="核对后长"
          width="80"
        />
        <el-table-column
          prop="checkWidth"
          label="核对后宽"
          width="80"
        />
        <el-table-column
          prop="checkHeight"
          label="核对后高"
          width="80"
        />
        <el-table-column
          prop="checkRebate"
          label="核对后返利"
          width="100"
        />
        <el-table-column
          prop="checkReturnBatchNo"
          label="核对后退货批次号"
          width="130"
        />
        <el-table-column
          prop="checkServiceFee"
          label="核对后服务费"
          width="120"
        />
        <el-table-column
          prop="checkTotalFee"
          label="核对后总费用"
          width="120"
        />
        <el-table-column
          label="操作"
          width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" class="action-link" @click="goDetail(scope.row)">
              查看详情
            </el-button>
            <template v-if="currentView !== 'myCC'">
              <template v-if="scope.row.status === '待处理' || scope.row.status === '已驳回'">
                <el-button type="primary" size="small" @click="handleDiff(scope.row)">
                  {{ scope.row.status === '已驳回' ? '重新处理' : '处理' }}
                </el-button>
                <el-button type="text" size="small" @click="showForwardDialog(scope.row)">
                  转发
                </el-button>
              </template>
              <template v-else-if="scope.row.status === '已处理'">
                <el-button type="primary" size="small" @click="auditDiff(scope.row)">
                  审核
                </el-button>
                <el-button type="text" size="small" @click="showForwardDialog(scope.row)">
                  转发
                </el-button>
              </template>
              <template v-else-if="scope.row.status === '已关闭'">
                <el-button type="text" size="small" @click="showForwardDialog(scope.row)">
                  转发
                </el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-area">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper, ->, total"
            :total="pagination.total"
          />
        </div>
      </div>
    </div>

    <el-dialog
      :visible="detailDialogVisible"
      :title="'成本差异单详情 - ' + currentDiff.diffBillNo"
      width="90%"
      :close-on-click-modal="false"
      @close="detailDialogVisible = false"
    >
      <el-tabs v-model="detailActiveTab" class="detail-tabs">
        <el-tab-pane label="差异详情" name="diffDetail">
          <div class="diff-detail">
            <div class="detail-section">
              <h3>概要信息</h3>
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">成本差异单号</span>
                  <span class="info-value">{{ currentDiff.diffBillNo }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">运单号</span>
                  <span class="info-value">{{ currentDiff.expressNo }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">账单周期</span>
                  <span class="info-value">{{ currentDiff.billCycle }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">差异原因</span>
                  <span class="info-value">{{ currentDiff.diffReason }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">处理方</span>
                  <span class="info-value">{{ currentDiff.handlerRole }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">处理状态</span>
                  <el-tag :type="getStatusType(currentDiff.status)">
                    {{ currentDiff.status }}
                  </el-tag>
                </div>
                <div class="info-item">
                  <span class="info-label">处理人</span>
                  <span class="info-value">{{ currentDiff.handlerName || '-' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">创建时间</span>
                  <span class="info-value">{{ currentDiff.createTime }}</span>
                </div>
              </div>
            </div>

            <div class="detail-section">
              <h3>差异对比</h3>
              <div class="compare-grid">
                <div class="compare-item">
                  <span class="compare-label">宝尊重量(kg)</span>
                  <span class="compare-value">{{ currentDiff.baozunWeight }}</span>
                </div>
                <div class="compare-item">
                  <span class="compare-label">物流商重量(kg)</span>
                  <span class="compare-value">{{ currentDiff.transportWeight }}</span>
                </div>
                <div class="compare-item">
                  <span class="compare-label">重量差异</span>
                  <span class="compare-value diff">{{ formatDiff(currentDiff.baozunWeight - currentDiff.transportWeight) }}</span>
                </div>
                <div class="compare-item">
                  <span class="compare-label">宝尊费用</span>
                  <span class="compare-value">{{ formatCurrency(currentDiff.baozunFee) }}</span>
                </div>
                <div class="compare-item">
                  <span class="compare-label">物流商费用</span>
                  <span class="compare-value">{{ formatCurrency(currentDiff.transportFee) }}</span>
                </div>
                <div class="compare-item">
                  <span class="compare-label">费用差异</span>
                  <span class="compare-value diff">{{ formatCurrency(currentDiff.baozunFee - currentDiff.transportFee) }}</span>
                </div>
              </div>
            </div>

            <div v-if="currentDiff.feedback" class="detail-section">
              <h3>处理方反馈内容</h3>
              <div class="feedback-content">
                <div class="feedback-item">
                  <span class="feedback-label">反馈类型</span>
                  <span class="feedback-value">{{ currentDiff.feedback.feedbackType }}</span>
                </div>
                <div class="feedback-item">
                  <span class="feedback-label">确认重量(kg)</span>
                  <span class="feedback-value">{{ currentDiff.feedback.confirmedWeight || '-' }}</span>
                </div>
                <div class="feedback-item">
                  <span class="feedback-label">处理说明</span>
                  <span class="feedback-value">{{ currentDiff.feedback.handlerDesc || '-' }}</span>
                </div>
                <div class="feedback-item">
                  <span class="feedback-label">反馈时间</span>
                  <span class="feedback-value">{{ currentDiff.feedback.feedbackTime || '-' }}</span>
                </div>
              </div>
            </div>

            <div v-if="currentDiff.ccFeedbacks && currentDiff.ccFeedbacks.length > 0 && isAuditor" class="detail-section cc-feedback-section">
              <h3>抄送方反馈（仅供审核参考）</h3>
              <div class="cc-feedback-list">
                <div v-for="(cc, index) in currentDiff.ccFeedbacks" :key="index" class="cc-feedback-item">
                  <div class="cc-feedback-header">
                    <span class="cc-name">{{ cc.ccName }}</span>
                    <span class="cc-time">{{ cc.ccTime }}</span>
                  </div>
                  <div class="cc-content">
                    <p><strong>核实意见：</strong>{{ cc.ccContent }}</p>
                    <p v-if="cc.ccAttachments && cc.ccAttachments.length > 0">
                      <strong>附件：</strong>
                      <span v-for="(att, i) in cc.ccAttachments" :key="i" class="attachment-link">{{ att }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="currentUserRole === 'CC'" class="detail-section">
              <h3>我的抄送反馈</h3>
              <div class="my-cc-feedback" v-if="!hasMyCCFeedback">
                <p class="no-feedback">尚未提交反馈</p>
                <el-button type="primary" size="small" @click="showCCFeedbackDialog">添加反馈</el-button>
              </div>
              <div class="my-cc-feedback" v-else>
                <div class="my-feedback-content">
                  <p><strong>反馈时间：</strong>{{ myCCFeedback.ccTime }}</p>
                  <p><strong>核实意见：</strong>{{ myCCFeedback.ccContent }}</p>
                </div>
                <el-button type="primary" size="small" @click="showCCFeedbackDialog">修改反馈</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="接口详情" name="interfaceDetail">
          <div class="interface-detail">
            <el-table :data="interfaceDetails" border style="width: 100%" size="small" max-height="500" :default-sort="{prop: 'pushTime', order: 'descending'}">
              <el-table-column prop="expressNo" label="快递单号" width="150"></el-table-column>
              <el-table-column prop="checkResult" label="核对结果" width="100"></el-table-column>
              <el-table-column prop="billDate" label="账单日期" width="100"></el-table-column>
              <el-table-column prop="pushTime" label="推送时间" width="150"></el-table-column>
              <el-table-column prop="batchNo" label="批次号" width="120"></el-table-column>
              <el-table-column prop="remark" label="备注" width="120"></el-table-column>
              <el-table-column prop="monthlyAccount" label="月结账号" width="120"></el-table-column>
              <el-table-column prop="service" label="服务" width="80"></el-table-column>
              <el-table-column prop="billingWeight" label="计费重量" width="100"></el-table-column>
              <el-table-column prop="senderProvince" label="寄件省" width="100"></el-table-column>
              <el-table-column prop="senderCity" label="寄件市" width="100"></el-table-column>
              <el-table-column prop="senderDistrict" label="寄件区" width="100"></el-table-column>
              <el-table-column prop="receiverProvince" label="收件省" width="100"></el-table-column>
              <el-table-column prop="receiverCity" label="收件市" width="100"></el-table-column>
              <el-table-column prop="receiverDistrict" label="收件区" width="100"></el-table-column>
              <el-table-column prop="firstWeightPrice" label="首重单价" width="100"></el-table-column>
              <el-table-column prop="continueWeightPrice" label="续重单价" width="100"></el-table-column>
              <el-table-column prop="interceptFlag" label="拦截标识" width="100"></el-table-column>
              <el-table-column prop="payableAmountFormula" label="应付金额计算公式" width="150"></el-table-column>
              <el-table-column prop="lightThrowFactor" label="轻抛系数" width="100"></el-table-column>
              <el-table-column prop="actualWeight" label="实际重量" width="100"></el-table-column>
              <el-table-column prop="productType" label="产类型" width="80"></el-table-column>
              <el-table-column prop="discount" label="折扣/促销" width="100"></el-table-column>
              <el-table-column prop="standardFreight" label="标准运费" width="100"></el-table-column>
              <el-table-column prop="discountedFreight" label="折后运费" width="100"></el-table-column>
              <el-table-column prop="declaredValue" label="声明价值" width="100"></el-table-column>
              <el-table-column prop="volume" label="体积" width="80"></el-table-column>
              <el-table-column prop="length" label="长" width="80"></el-table-column>
              <el-table-column prop="width" label="宽" width="80"></el-table-column>
              <el-table-column prop="height" label="高" width="80"></el-table-column>
              <el-table-column prop="rebate" label="返利" width="80"></el-table-column>
              <el-table-column prop="returnBatchNo" label="退货批次号" width="120"></el-table-column>
              <el-table-column prop="businessConfirm" label="商务确认" width="100"></el-table-column>
              <el-table-column prop="backup1" label="备用1" width="80"></el-table-column>
              <el-table-column prop="backup2" label="备用2" width="80"></el-table-column>
              <el-table-column prop="backup3" label="备用3" width="80"></el-table-column>
              <el-table-column prop="backup4" label="备用4" width="80"></el-table-column>
              <el-table-column prop="backup5" label="备用5" width="80"></el-table-column>
              <el-table-column prop="backup6" label="备用6" width="80"></el-table-column>
              <el-table-column prop="backup7" label="备用7" width="80"></el-table-column>
              <el-table-column prop="backup8" label="备用8" width="80"></el-table-column>
              <el-table-column prop="backup9" label="备用9" width="80"></el-table-column>
              <el-table-column prop="backup10" label="备用10" width="80"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="handleDialogVisible"
      :title="'处理差异单 - ' + currentDiff.diffBillNo"
      width="70%"
      :close-on-click-modal="false"
      @close="handleDialogVisible = false"
    >
      <div class="handle-form">
        <div v-if="currentDiff.status === '已驳回' && currentDiff.rejectInfo" class="reject-record">
          <div class="reject-record-title">
            <i class="el-icon-warning"></i>
            <span>驳回记录</span>
          </div>
          <div class="reject-record-content">
            <div class="reject-record-item">
              <span class="reject-label">驳回人：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectUser || currentDiff.rejectPerson || '-' }}</span>
            </div>
            <div class="reject-record-item">
              <span class="reject-label">驳回时间：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectTime || currentDiff.rejectTime || '-' }}</span>
            </div>
            <div class="reject-record-item">
              <span class="reject-label">驳回原因：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectReason || currentDiff.rejectReason || '-' }}</span>
            </div>
          </div>
        </div>

        <template v-if="currentDiff.handlerRole === '物流商' && currentDiff.diffReason === '退货运单无批次号'">
          <div class="summary-info">
            <div class="summary-row">
              <span class="summary-label">处理方：</span>
              <span class="summary-value">{{ currentDiff.handlerRole }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">差异原因：</span>
              <span class="summary-value">{{ currentDiff.diffReason }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">快递单号：</span>
              <span class="summary-value">{{ currentDiff.expressNo }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">BZ_品牌：</span>
              <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
            </div>
          </div>

          <div class="no-batch-banner">
            <i class="el-icon-info"></i>
            <span>退货运单无批次号：该运单为退货件，但系统中缺失退货批次号信息，请确认是否能补充该批次号。</span>
          </div>

          <el-form :model="handleForm" label-width="120px">
            <el-form-item label="核对结果" required>
              <span class="required-asterisk">*</span>
              <el-select v-model="handleForm.feedbackType">
                <el-option label="确认宝尊费用" value="确认宝尊费用" />
                <el-option label="确认物流商费用" value="确认物流商费用" />
                <el-option label="其他核对结果" value="其他核对结果" />
                <el-option label="补充退货批次号" value="补充退货批次号" />
              </el-select>
            </el-form-item>

            <template v-if="handleForm.feedbackType === '补充退货批次号'">
              <el-form-item label="退货批次号" required>
                <span class="required-asterisk">*</span>
                <el-input v-model="handleForm.returnBatchNo" placeholder="请输入退货批次号" />
              </el-form-item>
            </template>

            <el-form-item label="处理说明">
              <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填）" />
            </el-form-item>

            <el-form-item label="附件">
              <el-upload
                action="#"
                :file-list="handleForm.attachments"
                :limit="5"
                :before-upload="beforeUpload"
              >
                <el-button size="small" type="primary">上传附件</el-button>
                <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
              </el-upload>
            </el-form-item>
          </el-form>
        </template>

        <template v-else-if="currentDiff.handlerRole === '物流商'">
          <div class="summary-info">
            <div class="summary-row">
              <span class="summary-label">处理方：</span>
              <span class="summary-value">{{ currentDiff.handlerRole }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">差异原因：</span>
              <span class="summary-value">{{ currentDiff.diffReason }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">快递单号：</span>
              <span class="summary-value">{{ currentDiff.expressNo }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">BZ_品牌：</span>
              <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
            </div>
          </div>
          <el-form :model="handleForm" label-width="120px">
            <el-form-item label="核对结果" required>
              <span class="required-asterisk">*</span>
              <el-select v-model="handleForm.feedbackType" @change="onFeedbackTypeChange">
                <el-option label="确认宝尊费用" value="确认宝尊费用" />
                <el-option label="确认物流商费用" value="确认物流商费用" />
                <el-option label="其他核对结果" value="其他核对结果" />
                <el-option label="补充退货批次号" value="补充退货批次号" />
              </el-select>
            </el-form-item>

            <template v-if="handleForm.feedbackType === '其他核对结果'">
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">计费重量(kg)</span>
                  <el-input-number v-model="handleForm.confirmedWeight" :precision="3" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">实际重量(kg)</span>
                  <el-input-number v-model="handleForm.actualWeight" :precision="3" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">长(cm)</span>
                  <el-input-number v-model="handleForm.length" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">宽(cm)</span>
                  <el-input-number v-model="handleForm.width" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">高(cm)</span>
                  <el-input-number v-model="handleForm.height" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">体积(cm³)</span>
                  <el-input-number v-model="handleForm.volume" :precision="6" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">轻抛系数</span>
                  <el-input-number v-model="handleForm.lightThrowFactor" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item full-width">
                  <span class="required-asterisk">*</span>
                  <span class="label">寄件省市区</span>
                  <el-cascader 
                    v-model="handleSenderAddress" 
                    :options="addressOptions" 
                    placeholder="请选择寄件省市区"
                    style="width:100%"
                    @change="handleSenderAddressChange2"
                  ></el-cascader>
                </div>
                <div class="grid-item full-width">
                  <span class="required-asterisk">*</span>
                  <span class="label">收件省市区</span>
                  <el-cascader 
                    v-model="handleReceiverAddress" 
                    :options="addressOptions" 
                    placeholder="请选择收件省市区"
                    style="width:100%"
                    @change="handleReceiverAddressChange2"
                  ></el-cascader>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">首重单价(元)</span>
                  <el-input-number v-model="handleForm.firstWeightPrice" :precision="4" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">续重单价(元)</span>
                  <el-input-number v-model="handleForm.continueWeightPrice" :precision="4" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">标准运费(元)</span>
                  <el-input-number v-model="handleForm.standardFreight" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">折扣/促销(元)</span>
                  <el-input v-model="handleForm.discount" style="width:100%"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">协议条款11</span>
                  <el-input-number v-model="handleForm.agreementFee11" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">协议条款12</span>
                  <el-input-number v-model="handleForm.agreementFee12" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">协议条款618</span>
                  <el-input-number v-model="handleForm.agreementFee618" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">退回费</span>
                  <el-input-number v-model="handleForm.returnFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">春节不打烊</span>
                  <el-input-number v-model="handleForm.springFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">特殊地区加价费用(元)</span>
                  <el-input-number v-model="handleForm.specialAreaFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">其他费用(元)</span>
                  <el-input-number v-model="handleForm.otherFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">服务费(元)</span>
                  <el-input-number v-model="handleForm.serviceFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">保价费(元)</span>
                  <el-input-number v-model="handleForm.insuranceFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">折后运费(元)</span>
                  <el-input-number v-model="handleForm.discountedFreight" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">总费用(元)</span>
                  <el-input-number v-model="handleForm.totalFee" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">拦截标识</span>
                  <el-input v-model="handleForm.interceptFlag" style="width:100%"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">应付金额计算公式</span>
                  <el-input v-model="handleForm.payableAmountFormula" style="width:100%"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">产品类型</span>
                  <el-input v-model="handleForm.productType" style="width:100%"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">声明价值(元)</span>
                  <el-input-number v-model="handleForm.declaredValue" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">返利(元)</span>
                  <el-input-number v-model="handleForm.rebate" :precision="2" :min="0" style="width:100%"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="required-asterisk">*</span>
                  <span class="label">月结账号</span>
                  <el-input v-model="handleForm.monthlyAccount" style="width:100%"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">备注</span>
                  <el-input type="textarea" v-model="handleForm.remark" style="width:100%"></el-input>
                </div>
              </div>
            </template>

            <template v-if="handleForm.feedbackType === '补充退货批次号'">
              <el-form-item label="退货批次号" required>
                <el-input v-model="handleForm.returnBatchNo" />
              </el-form-item>
            </template>

            <el-form-item label="处理说明">
              <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
            </el-form-item>

            <el-form-item label="附件">
              <el-upload
                action="#"
                :file-list="handleForm.attachments"
                :limit="5"
                :before-upload="beforeUpload"
              >
                <el-button size="small" type="primary">上传附件</el-button>
                <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
              </el-upload>
            </el-form-item>
          </el-form>
        </template>

        <template v-else-if="currentDiff.handlerRole === 'IT'">
          <div class="summary-info">
            <div class="summary-row">
              <span class="summary-label">处理方：</span>
              <span class="summary-value">{{ currentDiff.handlerRole }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">差异原因：</span>
              <span class="summary-value">{{ currentDiff.diffReason }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">快递单号：</span>
              <span class="summary-value">{{ currentDiff.expressNo }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">BZ_品牌：</span>
              <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
            </div>
          </div>
          <el-form :model="handleForm" label-width="120px">
            <el-form-item label="核对结果" required>
              <span class="required-asterisk">*</span>
              <el-select v-model="handleForm.feedbackType">
                <el-option label="重新调用接口并重算" value="重新调用接口并重算" />
              </el-select>
            </el-form-item>
            <el-form-item label="处理说明">
              <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填）" />
            </el-form-item>
            <el-form-item label="附件">
              <el-upload
                action="#"
                :file-list="handleForm.attachments"
                :limit="5"
                :before-upload="beforeUpload"
              >
                <el-button size="small" type="primary">上传附件</el-button>
                <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
              </el-upload>
            </el-form-item>
          </el-form>
        </template>

        <template v-else-if="currentDiff.handlerRole === 'KA'">
          <div class="summary-info">
            <div class="summary-row">
              <span class="summary-label">处理方：</span>
              <span class="summary-value">{{ currentDiff.handlerRole }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">差异原因：</span>
              <span class="summary-value">{{ currentDiff.diffReason }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">快递单号：</span>
              <span class="summary-value">{{ currentDiff.expressNo }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">BZ_品牌：</span>
              <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
            </div>
          </div>
          <el-form :model="handleForm" label-width="150px">
            <template v-if="currentDiff.diffReason === '结算系统不存在'">
              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.belongConfirm" placeholder="请选择">
                  <el-option label="归属品牌" value="归属品牌" />
                  <el-option label="归属事业部" value="归属事业部" />
                  <el-option label="不结算" value="不结算" />
                </el-select>
              </el-form-item>

              <el-form-item label="仓库" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.warehouseCode" placeholder="请选择仓库" filterable>
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.warehouseCode"
                    :label="item.warehouseName"
                    :value="item.warehouseCode"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="店铺" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.storeCode" placeholder="请选择店铺" filterable>
                  <el-option
                    v-for="item in storeOptions"
                    :key="item.storeCode"
                    :label="item.storeName"
                    :value="item.storeCode"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </template>

            <template v-else-if="currentDiff.diffReason === '退货运单仅登记'">
              <div class="no-batch-banner">
                <i class="el-icon-info"></i>
                <span>退货运单仅登记：该退货运单仅完成登记、未实际退运入库，结算系统无运单费用记录，请确认运单归属的仓库与店铺。</span>
              </div>

              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.belongConfirm" placeholder="请选择">
                  <el-option label="确认归属" value="确认归属" />
                  <el-option label="不结算" value="不结算" />
                </el-select>
              </el-form-item>

              <el-form-item label="仓库" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.warehouseCode" placeholder="请选择仓库" filterable>
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.warehouseCode"
                    :label="item.warehouseName"
                    :value="item.warehouseCode"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="店铺" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.storeCode" placeholder="请选择店铺" filterable>
                  <el-option
                    v-for="item in storeOptions"
                    :key="item.storeCode"
                    :label="item.storeName"
                    :value="item.storeCode"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </template>

            <template v-else-if="currentDiff.diffReason === '标准运费差异'">
              <el-form-item label="处理说明" required>
                <span class="required-asterisk">*</span>
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（必填）" />
              </el-form-item>
              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </template>

            <template v-else>
              <el-form-item label="品牌归属" required>
                <el-select v-model="handleForm.brand">
                  <el-option label="NIKE-大陆" value="NIKE-大陆" />
                  <el-option label="ADIDAS-大陆" value="ADIDAS-大陆" />
                  <el-option label="PUMA-大陆" value="PUMA-大陆" />
                </el-select>
              </el-form-item>
              <el-form-item label="是否结算" required>
                <el-radio-group v-model="handleForm.isSettle">
                  <el-radio label="结算" />
                  <el-radio label="不结算" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
              </el-form-item>
            </template>
          </el-form>
        </template>

        <template v-else-if="currentDiff.handlerRole === '财务' && currentDiff.diffReason === '计费重量差异'">
          <div class="finance-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
            </div>

            <el-form :model="handleForm" label-width="120px" class="finance-form">
              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.feedbackType">
                  <el-option label="以物流商计费重量为准" value="以物流商计费重量为准" />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <template v-else-if="currentDiff.handlerRole === '财务'">
          <div class="finance-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
            </div>

            <div v-if="currentDiff.diffReason === '红冲运单'" class="red冲-banner">
              <i class="el-icon-info"></i>
              <span>红冲运单：该运单在物流商侧已做红冲处理，请确认红冲金额或将其转派给物流商核实。</span>
            </div>

            <el-form :model="handleForm" label-width="150px" class="finance-form">
              <template v-if="currentDiff.diffReason === '红冲运单'">
                <el-form-item label="核对结果" required>
                  <span class="required-asterisk">*</span>
                  <el-select v-model="handleForm.handleType">
                    <el-option label="确认红冲金额" value="确认红冲金额" />
                    <el-option label="转发物流商确认" value="转发物流商确认" />
                  </el-select>
                </el-form-item>
                
                <template v-if="handleForm.handleType === '确认红冲金额'">
                  <el-form-item label="红冲金额(元)" required>
                    <el-input-number 
                      v-model="handleForm.red冲Amount" 
                      :min="0" 
                      :step="0.01" 
                      :precision="2"
                      placeholder="请输入红冲金额"
                      disabled
                    ></el-input-number>
                  </el-form-item>
                </template>
                
                <template v-if="handleForm.handleType === '转发物流商确认'">
                  <el-form-item label="转发原因" required>
                    <el-input type="textarea" v-model="handleForm.forwardReason" :rows="3" maxlength="500" placeholder="请说明需要物流商进一步确认的原因（最大500字符）" />
                  </el-form-item>
                </template>

                <el-form-item label="处理说明">
                  <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填）" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="handleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </template>

              <template v-else-if="currentDiff.diffReason === '结算系统不存在' && currentDiff.systemBrandDetermined">
                <el-form-item label="核对结果" required>
                  <span class="required-asterisk">*</span>
                  <el-select v-model="handleForm.feedbackType">
                    <el-option label="确认品牌" value="确认品牌" />
                  </el-select>
                </el-form-item>

                <el-form-item label="品牌" required>
                  <span class="required-asterisk">*</span>
                  <el-select v-model="handleForm.brand">
                    <el-option label="NIKE-大陆" value="NIKE-大陆" />
                    <el-option label="ADIDAS-大陆" value="ADIDAS-大陆" />
                    <el-option label="PUMA-大陆" value="PUMA-大陆" />
                  </el-select>
                </el-form-item>

                <el-form-item label="处理说明">
                  <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="handleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </template>

              <template v-else-if="currentDiff.diffReason === '标准运费差异' || currentDiff.diffReason === '折后运费差异' || currentDiff.diffReason === '服务费差异'">
                <el-form-item label="核对结果" required>
                  <span class="required-asterisk">*</span>
                  <el-select v-model="handleForm.feedbackType">
                    <el-option label="确认宝尊费用" value="确认宝尊费用" />
                    <el-option label="确认物流商费用" value="确认物流商费用" />
                  </el-select>
                </el-form-item>
                <el-form-item label="处理说明">
                  <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填）" />
                </el-form-item>
                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="handleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </template>

              <template v-else-if="currentDiff.diffReason === '运单卡接口'">
                <el-form-item label="核对结果" required>
                  <span class="required-asterisk">*</span>
                  <el-select v-model="handleForm.feedbackType">
                    <el-option label="重新下发" value="重新下发" />
                  </el-select>
                </el-form-item>

                <el-form-item label="处理说明">
                  <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请说明补齐了哪些资料（最大500字符）" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="handleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </template>

              <template v-else>
                <el-form-item label="处理说明">
                  <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
                </el-form-item>
              </template>
            </el-form>

            <div v-if="currentDiff.diffReason === '运单卡接口'" class="interface-stuck-banner">
              <i class="el-icon-info"></i>
              <span>运单卡接口：该运单在接口数据下发过程中出现异常，请确认已补齐该运单的基础资料信息后，点击下方按钮重新下发运单接口数据。</span>
            </div>
          </div>
        </template>

        <template v-else-if="currentDiff.handlerRole === '配送组' && currentDiff.diffReason === '非宝尊月结'">
          <div class="delivery-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">月结账号：</span>
                <span class="summary-value">{{ currentDiff.monthlyAccount || '-' }}</span>
              </div>
            </div>

            <div class="non-baozun-banner">
              <i class="el-icon-info"></i>
              <span>非宝尊月结：该运单使用的月结账号不属于宝尊的标准月结体系，请根据业务实际情况判定是否仍需进行结算。</span>
            </div>

            <el-form :model="handleForm" label-width="120px" class="delivery-form">
              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.isSettle">
                  <el-option label="结算" value="结算" />
                  <el-option label="不结算" value="不结算" />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填，最大500字符）" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <template v-else-if="currentDiff.handlerRole === '配送组' && (currentDiff.diffReason === '运费未正常计算' || currentDiff.diffReason === '首重报价差异' || currentDiff.diffReason === '续重报价差异')">
          <div class="delivery-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
            </div>

            <div class="no-freight-banner">
              <i class="el-icon-info"></i>
              <span v-if="currentDiff.diffReason === '运费未正常计算'">运费未正常计算：该运单在系统计费过程中出现异常，请在修改合同或报价后，点击下方按钮触发系统重新计算运费。</span>
              <span v-else-if="currentDiff.diffReason === '首重报价差异'">首重报价差异：该运单的首重报价与系统记录不一致，请在修改合同报价后，点击下方按钮触发系统重新计算运费。</span>
              <span v-else-if="currentDiff.diffReason === '续重报价差异'">续重报价差异：该运单的续重报价与系统记录不一致，请在修改合同报价后，点击下方按钮触发系统重新计算运费。</span>
            </div>

            <el-form :model="handleForm" label-width="120px" class="delivery-form">
              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.feedbackType">
                  <el-option label="重新计算" value="重新计算" />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请说明本次修改了什么内容（最大500字符）" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <template v-else-if="currentDiff.handlerRole === '配送组' && currentDiff.diffReason === '物流商不存在'">
          <div class="delivery-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">物流商：</span>
                <span class="summary-value">{{ currentDiff.transportName || '-' }}</span>
              </div>
            </div>

            <el-form :model="handleForm" label-width="120px" class="delivery-form">
              <el-form-item label="核对结果" required>
                <span class="required-asterisk">*</span>
                <el-select v-model="handleForm.isSettle">
                  <el-option label="结算" value="结算" />
                  <el-option label="不结算" value="不结算" />
                </el-select>
              </el-form-item>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <template v-else-if="currentDiff.handlerRole === '配送组'">
          <div class="delivery-handle-section">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ currentDiff.handlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ currentDiff.diffReason }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">快递单号：</span>
                <span class="summary-value">{{ currentDiff.expressNo }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">BZ_品牌：</span>
                <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
              </div>
            </div>
            <el-form :model="handleForm" label-width="120px" class="delivery-form">
              <el-form-item label="核对结果" required>
                <el-select v-model="handleForm.feedbackType" @change="onFeedbackTypeChange">
                  <el-option label="确认宝尊费用" value="确认宝尊费用" />
                  <el-option label="确认物流商费用" value="确认物流商费用" />
                  <el-option label="其他核对结果" value="其他核对结果" />
                </el-select>
              </el-form-item>

              <template v-if="handleForm.feedbackType === '其他核对结果'">
                <div class="form-section-title">基础信息</div>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="handleForm.remark" :rows="2" maxlength="500" />
                </el-form-item>

                <div class="form-section-title">费用项</div>
                <el-form-item label="标准运费(元)">
                  <el-input-number v-model="handleForm.standardFreight" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">费用合计</div>
                <el-form-item label="总费用(元)">
                  <el-input-number v-model="handleForm.totalFee" :min="0" :step="0.01" />
                </el-form-item>
              </template>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="handleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </template>

        <template v-else>
          <el-form :model="handleForm" label-width="120px">
            <el-form-item label="修正数据">
              <div class="correct-section">
                <p>根据差异原因，请修正以下字段：</p>
                <el-input v-model="handleForm.correctData" placeholder="请输入修正内容" />
              </div>
            </el-form-item>
            <el-form-item label="处理说明">
              <el-input type="textarea" v-model="handleForm.handlerDesc" :rows="3" maxlength="500" />
            </el-form-item>
          </el-form>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">
          提交处理
        </el-button>
      </div>
    </el-dialog>

    <div v-if="showAuditPanel" class="audit-panel">
      <div class="panel-header" @click="toggleAuditPanel">
        <h3>审核差异单 - {{ currentDiff.diffBillNo }}</h3>
        <i :class="['el-icon', auditPanelExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
      </div>
      <div v-show="auditPanelExpanded" class="panel-content">
        <div class="audit-form">
          <div class="audit-section">
            <h4>责任方反馈内容（仅供参考）</h4>
            <div class="audit-info" v-if="currentDiff.handlerRole === 'IT'">
              <p><strong>操作摘要：</strong>已重新调用[物流商名称]接口查询运单，重算运费。（接口调用成功）</p>
              <p v-if="currentDiff.itRecalcResult"><strong>重算前费用：</strong>{{ formatCurrency(currentDiff.itRecalcResult.beforeFee) }} → <strong>重算后费用：</strong>{{ formatCurrency(currentDiff.itRecalcResult.afterFee) }}</p>
            </div>
            <div class="audit-info" v-else>
              <p><strong>反馈类型：</strong>{{ currentDiff.feedback && currentDiff.feedback.feedbackType || '-' }}</p>
              <p><strong>确认重量：</strong>{{ currentDiff.feedback && currentDiff.feedback.confirmedWeight || '-' }} kg</p>
              <p><strong>处理说明：</strong>{{ currentDiff.feedback && currentDiff.feedback.handlerDesc || '-' }}</p>
            </div>
          </div>

          <div v-if="currentDiff.ccFeedbacks && currentDiff.ccFeedbacks.length > 0" class="audit-section cc-feedback-section">
            <h4>抄送方反馈（仅供审核参考，抄送方可独立反馈）</h4>
            <div class="cc-feedback-list">
              <div v-for="(cc, index) in currentDiff.ccFeedbacks" :key="index" class="cc-feedback-item">
                <div class="cc-feedback-header">
                  <span class="cc-name">{{ cc.ccName }}</span>
                  <span class="cc-time">{{ cc.ccTime }}</span>
                </div>
                <div class="cc-content">
                  <p>核实意见：{{ cc.ccContent }}</p>
                  <p v-if="cc.ccAttachments && cc.ccAttachments.length > 0">
                    附件：<span v-for="(att, i) in cc.ccAttachments" :key="i" class="attachment-link">{{ att }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="audit-section">
            <h4>审核确认区（可修改）</h4>
            <p class="audit-tip">提示：以下数据默认带出物流商举证内容，审核人可修改全部字段。</p>
            
            <el-form :model="auditForm" label-width="120px">
              <el-form-item label="费用确认来源" required>
                <el-select v-model="auditForm.feeSource" @change="onFeeSourceChange">
                  <el-option label="宝尊费用" value="宝尊费用" />
                  <el-option label="物流商费用" value="物流商费用" />
                  <el-option label="系统重算" value="系统重算" />
                </el-select>
              </el-form-item>

              <template v-if="auditForm.feeSource === '系统重算'">
                <div class="form-section-title">基础信息</div>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="auditForm.remark" :rows="2" maxlength="500" />
                </el-form-item>
                <el-form-item label="月结账号">
                  <el-input v-model="auditForm.monthlyAccount" />
                </el-form-item>

                <div class="form-section-title">计费重量与尺寸</div>
                <el-form-item label="计费重量(kg)" required>
                  <el-input-number v-model="auditForm.billingWeight" :min="0" :step="0.001" />
                </el-form-item>
                <el-form-item label="实际重量(kg)">
                  <el-input-number v-model="auditForm.actualWeight" :min="0" :step="0.001" />
                </el-form-item>
                <el-form-item label="长(cm)">
                  <el-input-number v-model="auditForm.length" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="宽(cm)">
                  <el-input-number v-model="auditForm.width" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="高(cm)">
                  <el-input-number v-model="auditForm.height" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="体积(cm³)">
                  <el-input-number v-model="auditForm.volume" :min="0" :step="0.000001" />
                </el-form-item>
                <el-form-item label="轻抛系数">
                  <el-input-number v-model="auditForm.lightThrowFactor" :min="0" :step="1" />
                </el-form-item>

                <div class="form-section-title">地址信息</div>
                <el-form-item label="寄件省市区" required>
                  <el-cascader 
                    v-model="senderAddress" 
                    :options="addressOptions" 
                    placeholder="请选择寄件省市区"
                    @change="handleSenderAddressChange"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="收件省市区" required>
                  <el-cascader 
                    v-model="receiverAddress" 
                    :options="addressOptions" 
                    placeholder="请选择收件省市区"
                    @change="handleReceiverAddressChange"
                  ></el-cascader>
                </el-form-item>

                <div class="form-section-title">费用单价</div>
                <el-form-item label="首重单价(元)">
                  <el-input-number v-model="auditForm.firstWeightPrice" :min="0" :step="0.0001" />
                </el-form-item>
                <el-form-item label="续重单价(元)">
                  <el-input-number v-model="auditForm.continueWeightPrice" :min="0" :step="0.0001" />
                </el-form-item>
                <el-form-item label="返利(元)">
                  <el-input-number v-model="auditForm.rebate" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">费用项</div>
                <el-form-item label="标准运费(元)">
                  <el-input-number v-model="auditForm.standardFreight" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="折扣/促销">
                  <el-input v-model="auditForm.discount" />
                </el-form-item>

                <div class="form-section-title">协议条款费用</div>
                <el-form-item label="协议条款11(元)">
                  <el-input-number v-model="auditForm.agreementClause11" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="协议条款12(元)">
                  <el-input-number v-model="auditForm.agreementClause12" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="协议条款618(元)">
                  <el-input-number v-model="auditForm.agreementClause618" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">其他增值费用</div>
                <el-form-item label="退回费(元)">
                  <el-input-number v-model="auditForm.returnFee" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="春节不打烊(元)">
                  <el-input-number v-model="auditForm.springFestivalService" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="特殊地区加价费用(元)">
                  <el-input-number v-model="auditForm.specialAreaSurcharge" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="其他费用(元)">
                  <el-input-number v-model="auditForm.otherFee" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">其他信息</div>
                <el-form-item label="拦截标识">
                  <el-select v-model="auditForm.interceptFlag">
                    <el-option label="是" value="是" />
                    <el-option label="否" value="否" />
                  </el-select>
                </el-form-item>
                <el-form-item label="应付金额计算公式">
                  <el-input v-model="auditForm.payableAmountFormula" />
                </el-form-item>
                <el-form-item label="产品类型">
                  <el-input v-model="auditForm.productType" />
                </el-form-item>
                <el-form-item label="声明价值(元)">
                  <el-input-number v-model="auditForm.declaredValue" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">费用合计</div>
                <el-form-item label="总费用(元)">
                  <el-input-number v-model="auditForm.totalFee" :min="0" :step="0.01" />
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="recalculateAudit" v-if="auditForm.feeSource === '系统重算'">重新计算</el-button>
                </el-form-item>
              </template>

              <div class="form-section-title">系统重算结果（可修改）</div>
              <el-form-item label="确认标准运费(元)">
                <el-input-number v-model="auditForm.calcStandardFreight" :precision="2" :min="0" />
              </el-form-item>
              <el-form-item label="确认折后运费(元)">
                <el-input-number v-model="auditForm.calcDiscountedFreight" :precision="2" :min="0" />
              </el-form-item>
              <el-form-item label="确认服务费(元)">
                <el-input-number v-model="auditForm.calcServiceFee" :precision="2" :min="0" />
              </el-form-item>
              <el-form-item label="确认总费用(元)">
                <el-input-number v-model="auditForm.calcTotalFee" :precision="2" :min="0" />
              </el-form-item>
              <el-form-item label="确认返利(元)">
                <el-input-number v-model="auditForm.calcRebate" :precision="2" :min="0" />
              </el-form-item>

              <el-form-item label="审核意见">
                <el-input type="textarea" v-model="auditForm.auditComment" :rows="3" maxlength="500" />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="panel-footer">
          <el-button @click="closeAuditPanel">关闭</el-button>
          <el-button type="warning" @click="rejectDiff">驳回</el-button>
          <el-button type="primary" @click="passAudit">审核通过</el-button>
          <el-button @click="showForwardDialog(currentDiff)">转发</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      :visible="confirmDialogVisible"
      title="无差异确认"
      width="500px"
      @close="confirmDialogVisible = false"
    >
      <div class="confirm-content">
        <p class="confirm-title">确认该差异单已无差异，将彻底关闭？</p>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">差异单号：</span>
            <span class="value">{{ currentDiff.diffBillNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">运单号：</span>
            <span class="value">{{ currentDiff.expressNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">最终确认费用：</span>
            <span class="value">{{ formatCurrency(currentDiff.finalTotalFee || 0) }} 元</span>
          </div>
          <div class="info-item">
            <span class="label">确认费用来源：</span>
            <span class="value">系统重算</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible = false">取消</el-button>
        <el-button type="success" @click="confirmClose">确认关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="rejectDialogVisible"
      title="驳回原因"
      width="400px"
      @close="rejectDialogVisible = false"
    >
      <el-form :model="rejectForm">
        <el-form-item label="驳回原因" required>
          <el-input type="textarea" v-model="rejectForm.reason" :rows="3" maxlength="200" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReject">确认驳回</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="ccFeedbackDialogVisible"
      :title="hasMyCCFeedback ? '修改抄送反馈' : '添加抄送反馈'"
      width="500px"
      @close="ccFeedbackDialogVisible = false"
    >
      <el-form :model="ccFeedbackForm" label-width="100px">
        <el-form-item label="反馈意见">
          <el-input type="textarea" v-model="ccFeedbackForm.ccContent" :rows="4" maxlength="500" placeholder="请输入核实意见或备注（选填）" />
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            action="#"
            :file-list="ccFeedbackForm.ccAttachments"
            :limit="5"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">上传附件</el-button>
            <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ccFeedbackDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCCFeedback">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="forwardDialogVisible"
      title="转发任务"
      width="500px"
      @close="forwardDialogVisible = false"
    >
      <el-form :model="forwardForm" label-width="100px">
        <el-form-item label="处理方" required>
          <el-select v-model="forwardForm.handlerRole" style="width: 200px;" @change="onHandlerRoleChange">
            <el-option label="物流商" value="物流商" />
            <el-option label="财务" value="财务" />
            <el-option label="IT" value="IT" />
            <el-option label="配送组" value="配送组" />
            <el-option label="KA" value="KA" />
            <el-option label="运营" value="运营" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理人" required>
          <el-select v-model="forwardForm.handlerName" style="width: 200px;" filterable>
            <el-option v-for="user in availableHandlers" :key="user.name" :label="user.name" :value="user.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="转发原因">
          <el-input type="textarea" v-model="forwardForm.reason" :rows="3" maxlength="200" placeholder="请输入转发原因（选填）" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="forwardDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleForward">确认转发</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="showImportDialog"
      title="导入成本差异处理"
      width="450px"
      @close="showImportDialog = false"
    >
      <div class="import-content">
        <div class="import-upload-area">
          <el-upload
            class="import-upload"
            :action="importUrl"
            :before-upload="beforeImportUpload"
            :on-success="handleImportSuccess"
            :on-error="handleImportError"
            :file-list="importFileList"
            :auto-upload="false"
            ref="importUpload"
          >
            <el-button icon="el-icon-upload">选择文件</el-button>
          </el-upload>
          <a href="javascript:void(0)" class="download-template" @click="downloadTemplate">下载模板</a>
        </div>
        <div class="import-operation">
          <span class="operation-label">操作：</span>
          <el-radio-group v-model="importOperation">
            <el-radio label="转发" />
            <el-radio label="处理" />
            <el-radio label="审核" />
          </el-radio-group>
        </div>
        <div class="import-tip">
          <span class="tip-text">注：仅支持以下后缀文件：.xlsx</span>
        </div>
        <div v-if="importResult" class="import-result" :class="importResult.type">
          <p>{{ importResult.message }}</p>
          <el-button v-if="importResult.hasErrorFile" type="text" @click="downloadErrorFile">下载错误明细</el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImportDialog = false">取消</el-button>
        <el-button type="primary" @click="submitImport">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="showSyncDialog"
      title="同步物流商"
      width="700px"
      :close-on-click-modal="false"
      @close="showSyncDialog = false"
    >
      <div class="sync-dialog-content">
        <p class="sync-desc">即将通过接口同步以下待处理单据至对应物流商：</p>
        <div class="sync-table-wrapper">
          <el-table :data="syncLogisticsList" border style="width: 100%" size="small">
            <el-table-column prop="transportName" label="物流商" min-width="120" />
            <el-table-column prop="count" label="待同步数量" width="120" />
            <el-table-column prop="apiUrl" label="接口地址" min-width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.isApi" :title="scope.row.apiUrl">{{ scope.row.apiUrl }}</span>
                <span v-else style="color: #909399;">—（导入处理，跳过）</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="sync-summary">
          <p>共 <strong>{{ totalSyncCount }}</strong> 条单据待同步，将逐条调用各物流商推送接口。</p>
        </div>
        <div class="sync-notice">
          <p><strong>注意：</strong></p>
          <ul>
            <li>导入处理物流商不在此同步范围，请手动导出分发。</li>
            <li>同步仅推送数据，不修改单据状态。</li>
            <li>同步结果可在"导入导出结果"中查看。</li>
          </ul>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSyncDialog = false">取消</el-button>
        <el-button type="primary" @click="startSync" :loading="syncLoading">开始同步</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="showSettingsDialog"
      title="设置"
      width="500px"
      @close="showSettingsDialog = false"
    >
      <div class="settings-content">
        <el-form :model="settingsForm" label-width="140px">
          <el-form-item label="每页显示条数">
            <el-select v-model="settingsForm.pageSize">
              <el-option label="10条/页" :value="10" />
              <el-option label="20条/页" :value="20" />
              <el-option label="50条/页" :value="50" />
              <el-option label="100条/页" :value="100" />
            </el-select>
          </el-form-item>
          <el-form-item label="显示已关闭单据">
            <el-switch v-model="settingsForm.showClosed" />
          </el-form-item>
          <el-form-item label="自动刷新间隔(秒)">
            <el-select v-model="settingsForm.autoRefresh">
              <el-option label="不自动刷新" :value="0" />
              <el-option label="30秒" :value="30" />
              <el-option label="60秒" :value="60" />
              <el-option label="180秒" :value="180" />
            </el-select>
          </el-form-item>
          <el-form-item label="显示抄送反馈">
            <el-switch v-model="settingsForm.showCCFeedback" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSettingsDialog = false">取消</el-button>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="showImportExportResultDialog"
      title="导入导出结果"
      width="900px"
      @close="showImportExportResultDialog = false"
    >
      <div class="import-export-result">
        <div class="result-search">
          <el-form :model="resultFilterForm" inline>
            <el-form-item label="操作类型">
              <el-select v-model="resultFilterForm.operationType" placeholder="请选择">
                <el-option label="导入" value="导入" />
                <el-option label="导出" value="导出" />
                <el-option label="同步物流商" value="同步物流商" />
              </el-select>
            </el-form-item>
            <el-form-item label="操作状态">
              <el-select v-model="resultFilterForm.status" placeholder="请选择" multiple>
                <el-option label="成功" value="成功" />
                <el-option label="失败" value="失败" />
                <el-option label="处理中" value="处理中" />
                <el-option label="已取消" value="已取消" />
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-date-picker v-model="resultFilterForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-form-item>
            <el-form-item label="操作人">
              <el-input v-model="resultFilterForm.operator" placeholder="请输入" style="width: 150px;" />
            </el-form-item>
            <el-form-item label="操作名称">
              <el-input v-model="resultFilterForm.operationName" placeholder="请输入" style="width: 150px;" />
            </el-form-item>
            <el-form-item>
              <el-button @click="handleSearchResult">查询</el-button>
              <el-button @click="resetResultFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="result-table">
          <el-table :data="importExportResultList" border style="width: 100%">
            <el-table-column prop="operationName" label="操作名称" min-width="150" />
            <el-table-column prop="operationType" label="操作类型" width="80" />
            <el-table-column prop="operator" label="操作人" width="100" />
            <el-table-column prop="operationTime" label="操作时间" width="180" />
            <el-table-column prop="status" label="处理状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="resultStatus" label="结果状态" width="100" />
            <el-table-column prop="successCount" label="成功数量" width="80" />
            <el-table-column prop="failCount" label="失败数量" width="80" />
            <el-table-column prop="totalCount" label="总数量" width="80" />
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status === '成功'" type="text" @click="downloadResult(scope.row)">下载结果</el-button>
                <el-button type="text" @click="viewResultDetail(scope.row)">查看详情</el-button>
                <el-button v-if="scope.row.status === '失败'" type="text" @click="retryImport(scope.row)">重新导入</el-button>
                <el-button type="text" @click="deleteResult(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImportExportResultDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible="batchHandleDialogVisible"
      title="批量处理"
      width="70%"
      :close-on-click-modal="false"
      @close="batchHandleDialogVisible = false"
    >
      <div class="batch-handle-content">
        <div class="batch-summary">
          <div class="summary-item">
            <span class="summary-label">已选择</span>
            <span class="summary-value">{{ selectedIds.length }} 条单据</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">处理方</span>
            <span class="summary-value">{{ batchHandlerRole }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">差异原因</span>
            <span class="summary-value">{{ batchDiffReason }}</span>
          </div>
        </div>

        <div class="handle-form">
          <template v-if="batchHandlerRole === '物流商' && batchDiffReason === '退货运单无批次号'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>

            <div class="no-batch-banner">
              <i class="el-icon-info"></i>
              <span>退货运单无批次号：该运单为退货件，但系统中缺失退货批次号信息，请确认是否能补充该批次号。</span>
            </div>

            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="是否有批次号" required>
                <el-radio-group v-model="batchHandleForm.hasBatchNo">
                  <el-radio label="有">有</el-radio>
                  <el-radio label="无">无</el-radio>
                </el-radio-group>
              </el-form-item>

              <template v-if="batchHandleForm.hasBatchNo === '有'">
                <el-form-item label="退货批次号" required>
                  <el-input v-model="batchHandleForm.returnBatchNo" placeholder="请输入退货批次号" />
                </el-form-item>
              </template>

              <template v-if="batchHandleForm.hasBatchNo === '无'">
                <el-form-item label="无法提供原因" required>
                  <el-input type="textarea" v-model="batchHandleForm.noBatchReason" :rows="3" maxlength="500" placeholder="请说明为何无法提供批次号（最大500字符）" />
                </el-form-item>
              </template>

              <el-form-item label="处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明（选填）" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === '物流商'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="统一反馈结果类型" required>
                <el-select v-model="batchHandleForm.feedbackType" @change="onBatchFeedbackTypeChange">
                  <el-option label="确认宝尊费用" value="确认宝尊费用" />
                  <el-option label="确认物流商费用" value="确认物流商费用" />
                  <el-option label="其他核对结果" value="其他核对结果" disabled />
                  <el-option label="补充退货批次号" value="补充退货批次号" disabled />
                </el-select>
              </el-form-item>

              <div class="batch-tip">
                （注：其他核对结果和补充退货批次号不支持批量处理，请逐条操作）
              </div>

              <template v-if="batchHandleForm.feedbackType === '其他核对结果'">
                <div class="form-section-title">基础信息</div>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="batchHandleForm.remark" :rows="2" maxlength="500" />
                </el-form-item>
                <el-form-item label="月结账号">
                  <el-input v-model="batchHandleForm.monthlyAccount" />
                </el-form-item>

                <div class="form-section-title">计费重量与尺寸</div>
                <el-form-item label="计费重量(kg)">
                  <el-input-number v-model="batchHandleForm.confirmedWeight" :min="0" :step="0.001" />
                </el-form-item>
                <el-form-item label="实际重量(kg)">
                  <el-input-number v-model="batchHandleForm.actualWeight" :min="0" :step="0.001" />
                </el-form-item>
                <el-form-item label="长(cm)">
                  <el-input-number v-model="batchHandleForm.length" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="宽(cm)">
                  <el-input-number v-model="batchHandleForm.width" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="高(cm)">
                  <el-input-number v-model="batchHandleForm.height" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="体积(cm³)">
                  <el-input-number v-model="batchHandleForm.volume" :min="0" :step="0.000001" />
                </el-form-item>
                <el-form-item label="轻抛系数">
                  <el-input-number v-model="batchHandleForm.lightThrowFactor" :min="0" :step="1" />
                </el-form-item>

                <div class="form-section-title">地址信息</div>
                <el-form-item label="寄件省">
                  <el-input v-model="batchHandleForm.senderProvince" />
                </el-form-item>
                <el-form-item label="寄件市">
                  <el-input v-model="batchHandleForm.senderCity" />
                </el-form-item>
                <el-form-item label="寄件区">
                  <el-input v-model="batchHandleForm.senderDistrict" />
                </el-form-item>
                <el-form-item label="收件省">
                  <el-input v-model="batchHandleForm.receiverProvince" />
                </el-form-item>
                <el-form-item label="收件市">
                  <el-input v-model="batchHandleForm.receiverCity" />
                </el-form-item>
                <el-form-item label="收件区">
                  <el-input v-model="batchHandleForm.receiverDistrict" />
                </el-form-item>

                <div class="form-section-title">费用单价</div>
                <el-form-item label="首重单价(元)">
                  <el-input-number v-model="batchHandleForm.firstWeightPrice" :min="0" :step="0.0001" />
                </el-form-item>
                <el-form-item label="续重单价(元)">
                  <el-input-number v-model="batchHandleForm.continueWeightPrice" :min="0" :step="0.0001" />
                </el-form-item>

                <div class="form-section-title">费用项</div>
                <el-form-item label="标准运费(元)">
                  <el-input-number v-model="batchHandleForm.standardFreight" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="折扣/促销">
                  <el-input v-model="batchHandleForm.discount" />
                </el-form-item>

                <div class="form-section-title">协议条款费用</div>
                <el-form-item label="协议条款11(元)">
                  <el-input-number v-model="batchHandleForm.agreementClause11" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="协议条款12(元)">
                  <el-input-number v-model="batchHandleForm.agreementClause12" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="协议条款618(元)">
                  <el-input-number v-model="batchHandleForm.agreementClause618" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">其他增值费用</div>
                <el-form-item label="退回费(元)">
                  <el-input-number v-model="batchHandleForm.returnFee" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="春节不打烊(元)">
                  <el-input-number v-model="batchHandleForm.springFestivalService" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="特殊地区加价费用(元)">
                  <el-input-number v-model="batchHandleForm.specialAreaSurcharge" :min="0" :step="0.01" />
                </el-form-item>
                <el-form-item label="其他费用(元)">
                  <el-input-number v-model="batchHandleForm.otherFee" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">其他信息</div>
                <el-form-item label="拦截标识">
                  <el-select v-model="batchHandleForm.interceptFlag">
                    <el-option label="是" value="是" />
                    <el-option label="否" value="否" />
                  </el-select>
                </el-form-item>
                <el-form-item label="应付金额计算公式">
                  <el-input v-model="batchHandleForm.payableAmountFormula" />
                </el-form-item>
                <el-form-item label="产品类型">
                  <el-input v-model="batchHandleForm.productType" />
                </el-form-item>
                <el-form-item label="声明价值(元)">
                  <el-input-number v-model="batchHandleForm.declaredValue" :min="0" :step="0.01" />
                </el-form-item>

                <div class="form-section-title">费用合计</div>
                <el-form-item label="总费用(元)">
                  <el-input-number v-model="batchHandleForm.totalFee" :min="0" :step="0.01" />
                </el-form-item>
              </template>

              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === '财务'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="统一处理方式" required>
                <el-select v-model="batchHandleForm.feedbackType">
                  <el-option label="确认红冲金额" value="确认红冲金额" />
                  <el-option label="转发物流商确认" value="转发物流商确认" />
                  <el-option label="以物流商计费重量为准" value="以物流商计费重量为准" />
                  <el-option label="转发" value="转发" />
                  <el-option label="宝尊费用" value="宝尊费用" />
                  <el-option label="物流商费用" value="物流商费用" />
                  <el-option label="转发KA确认" value="转发KA确认" />
                </el-select>
              </el-form-item>

              <template v-if="batchHandleForm.feedbackType === '确认红冲金额'">
                <el-form-item label="红冲金额(元)" required>
                  <el-input-number v-model="batchHandleForm.redRushAmount" :min="0" :step="0.01" />
                </el-form-item>
              </template>

              <template v-if="batchHandleForm.feedbackType === '转发' || batchHandleForm.feedbackType === '转发物流商确认' || batchHandleForm.feedbackType === '转发KA确认'">
                <el-form-item label="转发处理方">
                  <el-select v-model="batchHandleForm.forwardHandlerRole">
                    <el-option label="物流商" value="物流商" />
                    <el-option label="财务" value="财务" />
                    <el-option label="IT" value="IT" />
                    <el-option label="配送组" value="配送组" />
                    <el-option label="KA" value="KA" />
                    <el-option label="运营" value="运营" />
                  </el-select>
                </el-form-item>
                <el-form-item label="转发处理人">
                  <el-select v-model="batchHandleForm.forwardHandlerName" filterable>
                    <el-option v-for="user in batchAvailableHandlers" :key="user.name" :label="user.name" :value="user.name" />
                  </el-select>
                </el-form-item>
                <el-form-item label="转发原因">
                  <el-input type="textarea" v-model="batchHandleForm.forwardReason" :rows="3" maxlength="200" />
                </el-form-item>
              </template>

              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === 'IT'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="统一处理方式">
                <el-select v-model="batchHandleForm.feedbackType">
                  <el-option label="重新调用接口并重算" value="重新调用接口并重算" />
                </el-select>
              </el-form-item>

              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === 'KA'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="品牌归属">
                <el-select v-model="batchHandleForm.brand">
                  <el-option v-for="brand in brandOptions" :key="brand.value" :label="brand.label" :value="brand.value" />
                </el-select>
              </el-form-item>

              <el-form-item label="是否结算">
                <el-radio-group v-model="batchHandleForm.isSettle">
                  <el-radio label="结算">结算</el-radio>
                  <el-radio label="不结算">不结算</el-radio>
                </el-radio-group>
              </el-form-item>

              <template v-if="batchHandleForm.isSettle === '不结算'">
                <el-form-item label="归属事业部">
                  <el-input v-model="batchHandleForm.businessUnit" />
                </el-form-item>
                <el-form-item label="不归属原因">
                  <el-input type="textarea" v-model="batchHandleForm.noBelongReason" :rows="3" maxlength="500" />
                </el-form-item>
              </template>

              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === '运营'">
            <div class="summary-info">
              <div class="summary-row">
                <span class="summary-label">处理方：</span>
                <span class="summary-value">{{ batchHandlerRole }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">差异原因：</span>
                <span class="summary-value">{{ batchDiffReason }}</span>
              </div>
            </div>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>

              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>

          <template v-else-if="batchHandlerRole === '配送组'">
            <template v-if="batchDiffReason === '运费未正常计算' || batchDiffReason === '首重报价差异' || batchDiffReason === '续重报价差异'">
              <div class="summary-info">
                <div class="summary-row">
                  <span class="summary-label">处理方：</span>
                  <span class="summary-value">{{ batchHandlerRole }}</span>
                </div>
                <div class="summary-row">
                  <span class="summary-label">差异原因：</span>
                  <span class="summary-value">{{ batchDiffReason }}</span>
                </div>
              </div>

              <div class="no-freight-banner">
                <i class="el-icon-info"></i>
                <span v-if="batchDiffReason === '运费未正常计算'">运费未正常计算：该运单在系统计费过程中出现异常，请在修改合同或报价后，点击下方按钮触发系统重新计算运费。</span>
                <span v-else-if="batchDiffReason === '首重报价差异'">首重报价差异：该运单的首重报价与系统记录不一致，请在修改合同报价后，点击下方按钮触发系统重新计算运费。</span>
                <span v-else-if="batchDiffReason === '续重报价差异'">续重报价差异：该运单的续重报价与系统记录不一致，请在修改合同报价后，点击下方按钮触发系统重新计算运费。</span>
              </div>

              <el-form :model="batchHandleForm" label-width="140px" class="delivery-form">
                <el-form-item label="统一处理说明">
                  <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="请说明本次修改了什么内容（最大500字符）" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="batchHandleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </el-form>
            </template>

            <template v-else-if="batchDiffReason === '物流商不存在'">
              <div class="summary-info">
                <div class="summary-row">
                  <span class="summary-label">处理方：</span>
                  <span class="summary-value">{{ batchHandlerRole }}</span>
                </div>
                <div class="summary-row">
                  <span class="summary-label">差异原因：</span>
                  <span class="summary-value">{{ batchDiffReason }}</span>
                </div>
              </div>

              <el-form :model="batchHandleForm" label-width="140px" class="delivery-form">
                <el-form-item label="是否结算" required>
                  <el-radio-group v-model="batchHandleForm.isSettle">
                    <el-radio label="结算">结算</el-radio>
                    <el-radio label="不结算">不结算</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="统一处理说明">
                  <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="batchHandleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </el-form>
            </template>

            <template v-else>
              <div class="summary-info">
                <div class="summary-row">
                  <span class="summary-label">处理方：</span>
                  <span class="summary-value">{{ batchHandlerRole }}</span>
                </div>
                <div class="summary-row">
                  <span class="summary-label">差异原因：</span>
                  <span class="summary-value">{{ batchDiffReason }}</span>
                </div>
              </div>
              <el-form :model="batchHandleForm" label-width="140px" class="delivery-form">
                <el-form-item label="统一处理方式" required>
                  <el-select v-model="batchHandleForm.feedbackType" @change="onBatchFeedbackTypeChange">
                    <el-option label="确认宝尊费用" value="确认宝尊费用" />
                    <el-option label="确认物流商费用" value="确认物流商费用" />
                    <el-option label="其他核对结果" value="其他核对结果" disabled />
                  </el-select>
                </el-form-item>

                <div class="batch-tip">
                  （注：其他核对结果不支持批量处理，请逐条操作）
                </div>

                <template v-if="batchHandleForm.feedbackType === '其他核对结果'">
                  <div class="form-section-title">基础信息</div>
                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="batchHandleForm.remark" :rows="2" maxlength="500" />
                  </el-form-item>

                  <div class="form-section-title">费用项</div>
                  <el-form-item label="标准运费(元)">
                    <el-input-number v-model="batchHandleForm.standardFreight" :min="0" :step="0.01" />
                  </el-form-item>

                  <div class="form-section-title">费用合计</div>
                  <el-form-item label="总费用(元)">
                    <el-input-number v-model="batchHandleForm.totalFee" :min="0" :step="0.01" />
                  </el-form-item>
                </template>

                <el-form-item label="统一处理说明">
                  <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" />
                </el-form-item>

                <el-form-item label="附件">
                  <el-upload
                    action="#"
                    :file-list="batchHandleForm.attachments"
                    :limit="5"
                    :before-upload="beforeUpload"
                  >
                    <el-button size="small" type="primary">上传附件</el-button>
                    <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                  </el-upload>
                </el-form-item>
              </el-form>
            </template>
          </template>

          <template v-else>
            <el-form :model="batchHandleForm" label-width="140px">
              <el-form-item label="统一处理说明">
                <el-input type="textarea" v-model="batchHandleForm.handlerDesc" :rows="3" maxlength="500" placeholder="选填，将应用于本次所有单据" />
              </el-form-item>
              <el-form-item label="附件">
                <el-upload
                  action="#"
                  :file-list="batchHandleForm.attachments"
                  :limit="5"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary">上传附件</el-button>
                  <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchHandleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchHandle">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CostDiffHandle',
  data() {
    return {
      currentUserRole: '管理员',
      currentView: 'all',
      selectedIds: [],
      showBatchActions: true,
      exportLoading: false,
      filterForm: {
        billCycle: '',
        expressNo: '',
        diffBillNo: '',
        handlerRole: [],
        diffReason: [],
        status: [],
        transportName: [],
        ccStatus: [],
        companyName: ''
      },
      tableHeight: 'calc(100vh - 320px)',
      showSyncDialog: false,
      originalDiffList: [],
      syncLoading: false,
      syncLogisticsList: [],
      totalSyncCount: 0,
      showSettingsDialog: false,
      settingsForm: {
        pageSize: 20,
        showClosed: false,
        autoRefresh: 0,
        showCCFeedback: true
      },
      diffReasons: [
        '逆向月结一口价差异',
        '退货运单无批次号',
        '退货运单仅登记',
        '运单接口不存在',
        '标准运费差异',
        '计费重量差异',
        '月结账号差异',
        '目的地省差异',
        '结算系统不存在',
        '物流商不存在',
        '运费未正常计算',
        '首重报价差异',
        '续重报价差异'
      ],
      brandOptions: [
        { value: '品牌A', label: '品牌A' },
        { value: '品牌B', label: '品牌B' },
        { value: '品牌C', label: '品牌C' },
        { value: '品牌D', label: '品牌D' },
        { value: '品牌E', label: '品牌E' },
        { value: '品牌F', label: '品牌F' }
      ],
      warehouseOptions: [
        { warehouseCode: 'WH-SH-01', warehouseName: '上海青浦一号仓', parkCode: 'PARK-SH-01', parkName: '青浦物流园', parkCostCenter: 'CC-PARK-SH01' },
        { warehouseCode: 'WH-SH-02', warehouseName: '上海松江仓', parkCode: 'PARK-SH-02', parkName: '松江智慧物流园', parkCostCenter: 'CC-PARK-SH02' },
        { warehouseCode: 'WH-JS-01', warehouseName: '苏州昆山花桥仓', parkCode: 'PARK-JS-01', parkName: '昆山花桥物流园', parkCostCenter: 'CC-PARK-JS01' },
        { warehouseCode: 'WH-GD-01', warehouseName: '广州南沙仓', parkCode: 'PARK-GD-01', parkName: '南沙港物流园', parkCostCenter: 'CC-PARK-GD01' },
        { warehouseCode: 'WH-ZJ-01', warehouseName: '杭州余杭仓', parkCode: 'PARK-ZJ-01', parkName: '余杭临平物流园', parkCostCenter: 'CC-PARK-ZJ01' }
      ],
      storeOptions: [
        { storeCode: 'STORE-NIKE-TM', storeName: 'NIKE天猫官方旗舰店', brand: 'NIKE-大陆', costCenter: 'CC-STORE-NIKE01' },
        { storeCode: 'STORE-NIKE-JD', storeName: 'NIKE京东自营旗舰店', brand: 'NIKE-大陆', costCenter: 'CC-STORE-NIKE02' },
        { storeCode: 'STORE-ADI-TM', storeName: 'ADIDAS天猫官方旗舰店', brand: 'ADIDAS-大陆', costCenter: 'CC-STORE-ADI01' },
        { storeCode: 'STORE-ADI-JD', storeName: 'ADIDAS京东自营旗舰店', brand: 'ADIDAS-大陆', costCenter: 'CC-STORE-ADI02' },
        { storeCode: 'STORE-PUMA-DY', storeName: 'PUMA抖音旗舰店', brand: 'PUMA-大陆', costCenter: 'CC-STORE-PUMA01' }
      ],
      provinceList: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
        '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省',
        '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区',
        '海南省', '重庆市', '四川省', '贵州省', '云南省',
        '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
        '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'
      ],
      addressOptions: [
        {
          value: '北京市',
          label: '北京市',
          children: [
            {
              value: '北京市',
              label: '北京市',
              children: [
                { value: '东城区', label: '东城区' },
                { value: '西城区', label: '西城区' },
                { value: '朝阳区', label: '朝阳区' },
                { value: '海淀区', label: '海淀区' },
                { value: '丰台区', label: '丰台区' },
                { value: '石景山区', label: '石景山区' }
              ]
            }
          ]
        },
        {
          value: '上海市',
          label: '上海市',
          children: [
            {
              value: '上海市',
              label: '上海市',
              children: [
                { value: '黄浦区', label: '黄浦区' },
                { value: '徐汇区', label: '徐汇区' },
                { value: '长宁区', label: '长宁区' },
                { value: '静安区', label: '静安区' },
                { value: '普陀区', label: '普陀区' },
                { value: '虹口区', label: '虹口区' },
                { value: '杨浦区', label: '杨浦区' },
                { value: '浦东新区', label: '浦东新区' }
              ]
            }
          ]
        },
        {
          value: '广东省',
          label: '广东省',
          children: [
            {
              value: '广州市',
              label: '广州市',
              children: [
                { value: '天河区', label: '天河区' },
                { value: '越秀区', label: '越秀区' },
                { value: '海珠区', label: '海珠区' },
                { value: '白云区', label: '白云区' },
                { value: '黄埔区', label: '黄埔区' },
                { value: '番禺区', label: '番禺区' }
              ]
            },
            {
              value: '深圳市',
              label: '深圳市',
              children: [
                { value: '福田区', label: '福田区' },
                { value: '罗湖区', label: '罗湖区' },
                { value: '南山区', label: '南山区' },
                { value: '宝安区', label: '宝安区' },
                { value: '龙岗区', label: '龙岗区' },
                { value: '龙华区', label: '龙华区' }
              ]
            },
            {
              value: '东莞市',
              label: '东莞市',
              children: [
                { value: '莞城区', label: '莞城区' },
                { value: '南城区', label: '南城区' },
                { value: '东城区', label: '东城区' },
                { value: '万江区', label: '万江区' }
              ]
            }
          ]
        },
        {
          value: '浙江省',
          label: '浙江省',
          children: [
            {
              value: '杭州市',
              label: '杭州市',
              children: [
                { value: '上城区', label: '上城区' },
                { value: '下城区', label: '下城区' },
                { value: '西湖区', label: '西湖区' },
                { value: '拱墅区', label: '拱墅区' },
                { value: '江干区', label: '江干区' },
                { value: '滨江区', label: '滨江区' }
              ]
            },
            {
              value: '宁波市',
              label: '宁波市',
              children: [
                { value: '海曙区', label: '海曙区' },
                { value: '江北区', label: '江北区' },
                { value: '北仑区', label: '北仑区' },
                { value: '镇海区', label: '镇海区' },
                { value: '鄞州区', label: '鄞州区' }
              ]
            }
          ]
        },
        {
          value: '江苏省',
          label: '江苏省',
          children: [
            {
              value: '南京市',
              label: '南京市',
              children: [
                { value: '玄武区', label: '玄武区' },
                { value: '秦淮区', label: '秦淮区' },
                { value: '鼓楼区', label: '鼓楼区' },
                { value: '建邺区', label: '建邺区' },
                { value: '栖霞区', label: '栖霞区' },
                { value: '雨花台区', label: '雨花台区' }
              ]
            },
            {
              value: '苏州市',
              label: '苏州市',
              children: [
                { value: '姑苏区', label: '姑苏区' },
                { value: '虎丘区', label: '虎丘区' },
                { value: '吴中区', label: '吴中区' },
                { value: '相城区', label: '相城区' },
                { value: '吴江区', label: '吴江区' }
              ]
            }
          ]
        },
        {
          value: '四川省',
          label: '四川省',
          children: [
            {
              value: '成都市',
              label: '成都市',
              children: [
                { value: '锦江区', label: '锦江区' },
                { value: '青羊区', label: '青羊区' },
                { value: '金牛区', label: '金牛区' },
                { value: '武侯区', label: '武侯区' },
                { value: '成华区', label: '成华区' },
                { value: '高新区', label: '高新区' }
              ]
            }
          ]
        },
        {
          value: '湖北省',
          label: '湖北省',
          children: [
            {
              value: '武汉市',
              label: '武汉市',
              children: [
                { value: '江岸区', label: '江岸区' },
                { value: '江汉区', label: '江汉区' },
                { value: '硚口区', label: '硚口区' },
                { value: '汉阳区', label: '汉阳区' },
                { value: '武昌区', label: '武昌区' },
                { value: '洪山区', label: '洪山区' }
              ]
            }
          ]
        },
        {
          value: '湖南省',
          label: '湖南省',
          children: [
            {
              value: '长沙市',
              label: '长沙市',
              children: [
                { value: '芙蓉区', label: '芙蓉区' },
                { value: '天心区', label: '天心区' },
                { value: '岳麓区', label: '岳麓区' },
                { value: '开福区', label: '开福区' },
                { value: '雨花区', label: '雨花区' }
              ]
            }
          ]
        },
        {
          value: '河南省',
          label: '河南省',
          children: [
            {
              value: '郑州市',
              label: '郑州市',
              children: [
                { value: '中原区', label: '中原区' },
                { value: '二七区', label: '二七区' },
                { value: '金水区', label: '金水区' },
                { value: '管城回族区', label: '管城回族区' },
                { value: '惠济区', label: '惠济区' }
              ]
            }
          ]
        },
        {
          value: '山东省',
          label: '山东省',
          children: [
            {
              value: '济南市',
              label: '济南市',
              children: [
                { value: '历下区', label: '历下区' },
                { value: '市中区', label: '市中区' },
                { value: '槐荫区', label: '槐荫区' },
                { value: '天桥区', label: '天桥区' },
                { value: '历城区', label: '历城区' }
              ]
            },
            {
              value: '青岛市',
              label: '青岛市',
              children: [
                { value: '市南区', label: '市南区' },
                { value: '市北区', label: '市北区' },
                { value: '黄岛区', label: '黄岛区' },
                { value: '崂山区', label: '崂山区' },
                { value: '城阳区', label: '城阳区' }
              ]
            }
          ]
        },
        {
          value: '天津市',
          label: '天津市',
          children: [
            {
              value: '天津市',
              label: '天津市',
              children: [
                { value: '和平区', label: '和平区' },
                { value: '河东区', label: '河东区' },
                { value: '河西区', label: '河西区' },
                { value: '南开区', label: '南开区' },
                { value: '河北区', label: '河北区' },
                { value: '红桥区', label: '红桥区' }
              ]
            }
          ]
        },
        {
          value: '重庆市',
          label: '重庆市',
          children: [
            {
              value: '渝中区',
              label: '渝中区',
              children: [
                { value: '解放碑街道', label: '解放碑街道' },
                { value: '朝天门街道', label: '朝天门街道' }
              ]
            },
            {
              value: '江北区',
              label: '江北区',
              children: [
                { value: '江北城街道', label: '江北城街道' },
                { value: '寸滩街道', label: '寸滩街道' }
              ]
            },
            {
              value: '南岸区',
              label: '南岸区',
              children: [
                { value: '南坪街道', label: '南坪街道' },
                { value: '弹子石街道', label: '弹子石街道' }
              ]
            }
          ]
        },
        {
          value: '安徽省',
          label: '安徽省',
          children: [
            {
              value: '合肥市',
              label: '合肥市',
              children: [
                { value: '瑶海区', label: '瑶海区' },
                { value: '庐阳区', label: '庐阳区' },
                { value: '蜀山区', label: '蜀山区' },
                { value: '包河区', label: '包河区' }
              ]
            }
          ]
        },
        {
          value: '福建省',
          label: '福建省',
          children: [
            {
              value: '福州市',
              label: '福州市',
              children: [
                { value: '鼓楼区', label: '鼓楼区' },
                { value: '台江区', label: '台江区' },
                { value: '仓山区', label: '仓山区' },
                { value: '晋安区', label: '晋安区' }
              ]
            },
            {
              value: '厦门市',
              label: '厦门市',
              children: [
                { value: '思明区', label: '思明区' },
                { value: '湖里区', label: '湖里区' },
                { value: '集美区', label: '集美区' },
                { value: '海沧区', label: '海沧区' }
              ]
            }
          ]
        },
        {
          value: '江西省',
          label: '江西省',
          children: [
            {
              value: '南昌市',
              label: '南昌市',
              children: [
                { value: '东湖区', label: '东湖区' },
                { value: '西湖区', label: '西湖区' },
                { value: '青云谱区', label: '青云谱区' },
                { value: '青山湖区', label: '青山湖区' }
              ]
            }
          ]
        },
        {
          value: '广西壮族自治区',
          label: '广西壮族自治区',
          children: [
            {
              value: '南宁市',
              label: '南宁市',
              children: [
                { value: '兴宁区', label: '兴宁区' },
                { value: '青秀区', label: '青秀区' },
                { value: '江南区', label: '江南区' },
                { value: '西乡塘区', label: '西乡塘区' }
              ]
            }
          ]
        },
        {
          value: '云南省',
          label: '云南省',
          children: [
            {
              value: '昆明市',
              label: '昆明市',
              children: [
                { value: '五华区', label: '五华区' },
                { value: '盘龙区', label: '盘龙区' },
                { value: '官渡区', label: '官渡区' },
                { value: '西山区', label: '西山区' }
              ]
            }
          ]
        },
        {
          value: '陕西省',
          label: '陕西省',
          children: [
            {
              value: '西安市',
              label: '西安市',
              children: [
                { value: '新城区', label: '新城区' },
                { value: '碑林区', label: '碑林区' },
                { value: '莲湖区', label: '莲湖区' },
                { value: '雁塔区', label: '雁塔区' },
                { value: '未央区', label: '未央区' }
              ]
            }
          ]
        },
        {
          value: '辽宁省',
          label: '辽宁省',
          children: [
            {
              value: '沈阳市',
              label: '沈阳市',
              children: [
                { value: '和平区', label: '和平区' },
                { value: '沈河区', label: '沈河区' },
                { value: '大东区', label: '大东区' },
                { value: '皇姑区', label: '皇姑区' },
                { value: '铁西区', label: '铁西区' }
              ]
            },
            {
              value: '大连市',
              label: '大连市',
              children: [
                { value: '中山区', label: '中山区' },
                { value: '西岗区', label: '西岗区' },
                { value: '沙河口区', label: '沙河口区' },
                { value: '甘井子区', label: '甘井子区' }
              ]
            }
          ]
        },
        {
          value: '黑龙江省',
          label: '黑龙江省',
          children: [
            {
              value: '哈尔滨市',
              label: '哈尔滨市',
              children: [
                { value: '道里区', label: '道里区' },
                { value: '南岗区', label: '南岗区' },
                { value: '道外区', label: '道外区' },
                { value: '香坊区', label: '香坊区' }
              ]
            }
          ]
        },
        {
          value: '吉林省',
          label: '吉林省',
          children: [
            {
              value: '长春市',
              label: '长春市',
              children: [
                { value: '朝阳区', label: '朝阳区' },
                { value: '南关区', label: '南关区' },
                { value: '宽城区', label: '宽城区' },
                { value: '二道区', label: '二道区' },
                { value: '绿园区', label: '绿园区' }
              ]
            }
          ]
        },
        {
          value: '内蒙古自治区',
          label: '内蒙古自治区',
          children: [
            {
              value: '呼和浩特市',
              label: '呼和浩特市',
              children: [
                { value: '新城区', label: '新城区' },
                { value: '回民区', label: '回民区' },
                { value: '玉泉区', label: '玉泉区' },
                { value: '赛罕区', label: '赛罕区' }
              ]
            }
          ]
        },
        {
          value: '山西省',
          label: '山西省',
          children: [
            {
              value: '太原市',
              label: '太原市',
              children: [
                { value: '小店区', label: '小店区' },
                { value: '迎泽区', label: '迎泽区' },
                { value: '杏花岭区', label: '杏花岭区' },
                { value: '尖草坪区', label: '尖草坪区' }
              ]
            }
          ]
        },
        {
          value: '河北省',
          label: '河北省',
          children: [
            {
              value: '石家庄市',
              label: '石家庄市',
              children: [
                { value: '长安区', label: '长安区' },
                { value: '桥西区', label: '桥西区' },
                { value: '新华区', label: '新华区' },
                { value: '裕华区', label: '裕华区' }
              ]
            }
          ]
        },
        {
          value: '贵州省',
          label: '贵州省',
          children: [
            {
              value: '贵阳市',
              label: '贵阳市',
              children: [
                { value: '云岩区', label: '云岩区' },
                { value: '南明区', label: '南明区' },
                { value: '花溪区', label: '花溪区' },
                { value: '乌当区', label: '乌当区' }
              ]
            }
          ]
        },
        {
          value: '新疆维吾尔自治区',
          label: '新疆维吾尔自治区',
          children: [
            {
              value: '乌鲁木齐市',
              label: '乌鲁木齐市',
              children: [
                { value: '天山区', label: '天山区' },
                { value: '沙依巴克区', label: '沙依巴克区' },
                { value: '新市区', label: '新市区' },
                { value: '水磨沟区', label: '水磨沟区' }
              ]
            }
          ]
        },
        {
          value: '甘肃省',
          label: '甘肃省',
          children: [
            {
              value: '兰州市',
              label: '兰州市',
              children: [
                { value: '城关区', label: '城关区' },
                { value: '七里河区', label: '七里河区' },
                { value: '西固区', label: '西固区' },
                { value: '安宁区', label: '安宁区' }
              ]
            }
          ]
        },
        {
          value: '宁夏回族自治区',
          label: '宁夏回族自治区',
          children: [
            {
              value: '银川市',
              label: '银川市',
              children: [
                { value: '兴庆区', label: '兴庆区' },
                { value: '西夏区', label: '西夏区' },
                { value: '金凤区', label: '金凤区' }
              ]
            }
          ]
        },
        {
          value: '青海省',
          label: '青海省',
          children: [
            {
              value: '西宁市',
              label: '西宁市',
              children: [
                { value: '城东区', label: '城东区' },
                { value: '城中区', label: '城中区' },
                { value: '城西区', label: '城西区' },
                { value: '城北区', label: '城北区' }
              ]
            }
          ]
        },
        {
          value: '西藏自治区',
          label: '西藏自治区',
          children: [
            {
              value: '拉萨市',
              label: '拉萨市',
              children: [
                { value: '城关区', label: '城关区' },
                { value: '堆龙德庆区', label: '堆龙德庆区' }
              ]
            }
          ]
        },
        {
          value: '海南省',
          label: '海南省',
          children: [
            {
              value: '海口市',
              label: '海口市',
              children: [
                { value: '秀英区', label: '秀英区' },
                { value: '龙华区', label: '龙华区' },
                { value: '琼山区', label: '琼山区' },
                { value: '美兰区', label: '美兰区' }
              ]
            },
            {
              value: '三亚市',
              label: '三亚市',
              children: [
                { value: '海棠区', label: '海棠区' },
                { value: '吉阳区', label: '吉阳区' },
                { value: '天涯区', label: '天涯区' },
                { value: '崖州区', label: '崖州区' }
              ]
            }
          ]
        },
        {
          value: '香港特别行政区',
          label: '香港特别行政区',
          children: [
            {
              value: '香港',
              label: '香港',
              children: [
                { value: '香港岛', label: '香港岛' },
                { value: '九龙', label: '九龙' },
                { value: '新界', label: '新界' }
              ]
            }
          ]
        },
        {
          value: '澳门特别行政区',
          label: '澳门特别行政区',
          children: [
            {
              value: '澳门',
              label: '澳门',
              children: [
                { value: '澳门半岛', label: '澳门半岛' },
                { value: '氹仔岛', label: '氹仔岛' },
                { value: '路环岛', label: '路环岛' }
              ]
            }
          ]
        },
        {
          value: '台湾省',
          label: '台湾省',
          children: [
            {
              value: '台北市',
              label: '台北市',
              children: [
                { value: '中正区', label: '中正区' },
                { value: '大同区', label: '大同区' },
                { value: '中山区', label: '中山区' },
                { value: '松山区', label: '松山区' }
              ]
            }
          ]
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 100
      },
      diffList: [
        {
          id: '1',
          diffBillNo: 'CD20240701-001',
          billCycle: '2024-07',
          expressNo: 'SF5192529203170',
          transportName: '顺丰快递',
          baozunWeight: 1.5,
          transportWeight: 2.0,
          baozunFee: 25.00,
          transportFee: 30.00,
          diffReason: '计费重量差异',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-01 10:30:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['周九', '吴十'],
          checkBrand: '品牌A',
          checkDiscount: '满100减10',
          checkAgreementClause11: 5.00,
          checkAgreementClause12: 3.00,
          checkAgreementClause618: 2.00,
          checkReturnFee: 0.00,
          checkSpringFestivalService: 0.00,
          checkSpecialAreaSurcharge: 0.00,
          checkOtherFee: 0.00,
          checkPayableAmountFormula: '首重10元+续重5元/kg',
          checkInsuranceFee: 2.00,
          finalRebate: 5.00,
          finalActualWeight: 1.5,
          finalDiscount: '满100减10',
          finalAgreementClause11: 5.00,
          finalAgreementClause12: 3.00,
          finalAgreementClause618: 2.00,
          finalReturnFee: 0.00,
          finalSpringFestivalService: 0.00,
          finalSpecialAreaSurcharge: 0.00,
          finalOtherFee: 0.00,
          finalInterceptFlag: '否',
          finalPayableAmountFormula: '首重10元+续重5元/kg',
          finalInsuranceFee: 2.00,
          finalBrand: '品牌A'
        },
        {
          id: '2',
          diffBillNo: 'CD20240701-002',
          billCycle: '2024-07',
          expressNo: 'SF5192529203171',
          transportName: '顺丰快递',
          baozunWeight: 3.0,
          transportWeight: 3.0,
          baozunFee: 45.00,
          transportFee: 50.00,
          diffReason: '运单接口不存在',
          handlerRole: 'IT',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-01 11:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['张三']
        },
        {
          id: '3',
          diffBillNo: 'CD20240701-003',
          billCycle: '2024-07',
          expressNo: 'JD1234567890',
          transportName: '京东物流',
          baozunWeight: 10.0,
          transportWeight: 10.0,
          baozunFee: 120.00,
          transportFee: 100.00,
          diffReason: '标准运费差异',
          handlerRole: 'KA',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-02 09:30:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['陈十三', '刘十四']
        },
        {
          id: '4',
          diffBillNo: 'CD20240701-004',
          billCycle: '2024-07',
          expressNo: 'ZTO5555666677',
          transportName: '中通快递',
          baozunWeight: 1.5,
          transportWeight: 1.5,
          baozunFee: 15.00,
          transportFee: 18.00,
          diffReason: '目的地省差异',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-03 10:30:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['郑十一']
        },
        {
          id: '5',
          diffBillNo: 'CD20240701-005',
          billCycle: '2024-07',
          expressNo: 'YTO9876543210',
          transportName: '圆通快递',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 18.00,
          transportFee: 22.00,
          diffReason: '计费重量差异',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-01 15:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['李四']
        },
        {
          id: '6',
          diffBillNo: 'CD20240701-006',
          billCycle: '2024-07',
          expressNo: 'YTO1234567890',
          transportName: '圆通快递',
          baozunWeight: 2.5,
          transportWeight: 2.5,
          baozunFee: 20.00,
          transportFee: 20.00,
          diffReason: '月结账号差异',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-02 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['周九']
        },
        {
          id: '36',
          diffBillNo: 'CD20240701-036',
          billCycle: '2024-07',
          expressNo: 'SF1234567890',
          transportName: '顺丰速运',
          baozunWeight: 1.0,
          transportWeight: 1.2,
          baozunFee: 12.00,
          transportFee: 14.40,
          diffReason: '计费重量差异',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-12 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['李四'],
          bzBrand: '品牌A',
          logisticsProvider: '顺丰速运',
          billPeriod: '2024-07'
        },
        {
          id: '21',
          diffBillNo: 'CD20240701-021',
          billCycle: '2024-07',
          expressNo: 'UNKNOWN123456789',
          transportName: '顺丰快递',
          baozunWeight: null,
          transportWeight: 1.5,
          baozunFee: null,
          transportFee: 15.00,
          diffReason: '结算系统不存在',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-06 08:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['郑十一'],
          bzBrand: '品牌A',
          systemBrandDetermined: true
        },
        {
          id: '22',
          diffBillNo: 'CD20240701-022',
          billCycle: '2024-07',
          expressNo: 'UNKNOWN987654321',
          transportName: '圆通快递',
          baozunWeight: null,
          transportWeight: 2.0,
          baozunFee: null,
          transportFee: 18.00,
          diffReason: '结算系统不存在',
          handlerRole: 'KA',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-06 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['张三']
        },
        {
          id: '38',
          diffBillNo: 'CD20240701-038',
          billCycle: '2024-07',
          expressNo: 'RET202407060001',
          transportName: '顺丰快递',
          baozunWeight: null,
          transportWeight: 1.2,
          baozunFee: null,
          transportFee: 12.00,
          diffReason: '退货运单仅登记',
          handlerRole: 'KA',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-06 09:30:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['张三']
        },
        {
          id: '25',
          diffBillNo: 'CD20240701-025',
          billCycle: '2024-07',
          expressNo: 'YTO1234567890',
          transportName: '圆通速递',
          baozunWeight: 5.0,
          transportWeight: 5.0,
          baozunFee: 60.00,
          transportFee: 60.00,
          diffReason: '红冲运单',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-07 10:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['王五'],
          bzBrand: '品牌B'
        },
        {
          id: '26',
          diffBillNo: 'CD20240701-026',
          billCycle: '2024-07',
          expressNo: 'EMS9876543210',
          transportName: 'EMS',
          baozunWeight: 3.0,
          transportWeight: 3.0,
          baozunFee: 45.00,
          transportFee: 45.00,
          diffReason: '红冲运单',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-08 11:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['赵六'],
          bzBrand: '品牌C',
          systemBrandDetermined: true,
          red冲Amount: 45.00
        },
        {
          id: '27',
          diffBillNo: 'CD20240701-027',
          billCycle: '2024-07',
          expressNo: 'SF1234567890123',
          transportName: '顺丰快递',
          baozunWeight: 8.0,
          transportWeight: 8.0,
          baozunFee: 120.00,
          transportFee: 0.00,
          diffReason: '运单接口不存在',
          handlerRole: 'IT',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-01 10:30:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['张三'],
          bzBrand: '品牌A',
          systemBrandDetermined: true,
          red冲Amount: 120.00,
          billType: '退货'
        },
        {
          id: '28',
          diffBillNo: 'CD20240701-028',
          billCycle: '2024-07',
          expressNo: 'YTO9876543210',
          transportName: '圆通速递',
          baozunWeight: 3.0,
          transportWeight: 3.0,
          baozunFee: 35.00,
          transportFee: 35.00,
          diffReason: '非宝尊月结',
          handlerRole: '配送组',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-10 14:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['王五'],
          bzBrand: '品牌A',
          monthlyAccount: 'YTO20240601'
        },
        {
          id: '30',
          diffBillNo: 'CD20240701-030',
          billCycle: '2024-07',
          expressNo: 'JD9876543210001',
          transportName: '京东物流',
          baozunWeight: null,
          transportWeight: 5.0,
          baozunFee: null,
          transportFee: 45.00,
          diffReason: '运费未正常计算',
          handlerRole: '配送组',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-10 16:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['钱七'],
          bzBrand: '品牌C'
        },
        {
          id: '31',
          diffBillNo: 'CD20240701-031',
          billCycle: '2024-07',
          expressNo: 'YT0123456789001',
          transportName: '圆通速递',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 15.00,
          transportFee: 18.00,
          diffReason: '首重报价差异',
          handlerRole: '配送组',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-11 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['孙八'],
          bzBrand: '品牌A'
        },
        {
          id: '33',
          diffBillNo: 'CD20240701-033',
          billCycle: '2024-07',
          expressNo: 'YD1234567890001',
          transportName: '韵达快递',
          baozunWeight: 5.0,
          transportWeight: 5.0,
          baozunFee: 30.00,
          transportFee: 35.00,
          diffReason: '续重报价差异',
          handlerRole: '配送组',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-11 10:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['周九'],
          bzBrand: '品牌B'
        },
        {
          id: '32',
          diffBillNo: 'CD20240701-032',
          billCycle: '2024-07',
          expressNo: 'SF9876543210002',
          transportName: '顺丰速运',
          baozunWeight: 4.0,
          transportWeight: 4.0,
          baozunFee: 38.00,
          transportFee: 38.00,
          diffReason: '运单卡接口',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-10 17:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['孙八'],
          bzBrand: '品牌D'
        },
        {
          id: '29',
          diffBillNo: 'CD20240701-029',
          billCycle: '2024-07',
          expressNo: 'SF9876543210001',
          transportName: '顺丰速运',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 25.00,
          transportFee: 25.00,
          diffReason: '退货运单无批次号',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-10 15:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['赵六'],
          bzBrand: '品牌B'
        },
        {
          id: '23',
          diffBillNo: 'CD20240701-023',
          billCycle: '2024-07',
          expressNo: 'UNKNOWN5555666677',
          transportName: '未知物流商',
          baozunWeight: null,
          transportWeight: 3.0,
          baozunFee: null,
          transportFee: 25.00,
          diffReason: '物流商不存在',
          handlerRole: '配送组',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-06 10:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['李四']
        },
        {
          id: '7',
          diffBillNo: 'CD20240701-007',
          billCycle: '2024-07',
          expressNo: 'YTO1234567890',
          transportName: '圆通快递',
          baozunWeight: 2.5,
          transportWeight: 2.5,
          baozunFee: 20.00,
          transportFee: 20.00,
          diffReason: '月结账号差异',
          handlerRole: '财务',
          status: '已处理',
          handlerName: '李四',
          createTime: '2024-07-02 09:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            confirmedWeight: 2.5,
            handlerDesc: '已确认月结账号正确',
            feedbackTime: '2024-07-02 14:00:00'
          },
          ccFeedbacks: [
            {
              ccName: '周九',
              ccTime: '2024-07-03 10:30:00',
              ccContent: '核实意见：重量数据与仓库记录一致，建议按宝尊数据结算。',
              ccAttachments: ['核对清单.xlsx']
            }
          ],
          ccUsers: ['周九']
        },
        {
          id: '8',
          diffBillNo: 'CD20240701-008',
          billCycle: '2024-07',
          expressNo: 'SF5192529203172',
          transportName: '顺丰快递',
          baozunWeight: 1.0,
          transportWeight: 1.0,
          baozunFee: 15.00,
          transportFee: 15.00,
          diffReason: '运单接口不存在',
          handlerRole: 'IT',
          status: '已处理',
          handlerName: '张小明',
          createTime: '2024-07-03 10:00:00',
          ccFeedbackStatus: '待反馈',
          feedback: {
            feedbackType: '接口重算',
            handlerDesc: '重新调用接口成功，差异已消除',
            feedbackTime: '2024-07-03 15:00:00'
          },
          ccUsers: ['陈十三']
        },
        {
          id: '9',
          diffBillNo: 'CD20240701-009',
          billCycle: '2024-07',
          expressNo: 'SF5192529203173',
          transportName: '顺丰快递',
          baozunWeight: 5.0,
          transportWeight: 5.0,
          baozunFee: 80.00,
          transportFee: 80.00,
          diffReason: '标准运费差异',
          handlerRole: '物流商',
          status: '已关闭',
          handlerName: '赵六',
          createTime: '2024-07-01 14:00:00',
          ccFeedbackStatus: '已反馈',
          closeReason: '无差异确认',
          closeTime: '2024-07-05 16:00:00',
          closeUser: '王五',
          ccUsers: ['张三']
        },
        {
          id: '11',
          diffBillNo: 'CD20240701-011',
          billCycle: '2024-07',
          expressNo: 'YTO9876543210',
          transportName: '圆通快递',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 18.00,
          transportFee: 22.00,
          diffReason: '计费重量差异',
          handlerRole: '配送组',
          status: '已驳回',
          handlerName: '周九',
          createTime: '2024-07-01 15:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认物流商费用',
            confirmedWeight: 2.0,
            handlerDesc: '配送记录显示实际重量为2kg',
            feedbackTime: '2024-07-02 11:00:00'
          },
          rejectInfo: {
            rejectUser: '王五',
            rejectTime: '2024-07-02 16:00:00',
            rejectReason: '配送组反馈数据与系统记录不一致，需重新核实'
          },
          ccUsers: ['李四']
        },
        {
          id: '13',
          diffBillNo: 'CD20240701-013',
          billCycle: '2024-07',
          expressNo: 'EMS1111222233',
          transportName: 'EMS',
          baozunWeight: 0.5,
          transportWeight: 0.5,
          baozunFee: 25.00,
          transportFee: 25.00,
          diffReason: '逆向月结一口价差异',
          handlerRole: 'KA',
          status: '已处理',
          handlerName: '王十二',
          createTime: '2024-07-02 14:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            brand: '品牌A',
            isSettle: '结算',
            handlerDesc: '确认品牌归属并同意结算',
            feedbackTime: '2024-07-03 09:00:00'
          },
          ccUsers: ['刘十四']
        },
        {
          id: '32',
          diffBillNo: 'CDH20240701-000005',
          billCycle: '2024-07',
          expressNo: 'YD20240701005',
          transportName: '韵达快递',
          baozunWeight: null,
          transportWeight: 1.5,
          baozunFee: null,
          transportFee: 15.00,
          diffReason: '结算系统不存在',
          handlerRole: 'KA',
          status: '已处理',
          handlerName: '周九',
          createTime: '2024-07-01 09:30:00',
          feedbackTime: '2024-07-04 09:00:00',
          ccFeedbackStatus: '已反馈',
          checkBrand: 'Nike',
          checkDiscount: '',
          checkAgreementClause11: 0.00,
          checkAgreementClause12: 0.00,
          checkAgreementClause618: 0.00,
          checkReturnFee: 0.00,
          checkSpringFestivalService: 0.00,
          checkSpecialAreaSurcharge: 0.00,
          checkOtherFee: 0.00,
          checkPayableAmountFormula: '',
          checkInsuranceFee: 0.00,
          finalRebate: 0.00,
          finalActualWeight: 1.5,
          finalDiscount: '',
          finalAgreementClause11: 0.00,
          finalAgreementClause12: 0.00,
          finalAgreementClause618: 0.00,
          finalReturnFee: 0.00,
          finalSpringFestivalService: 0.00,
          finalSpecialAreaSurcharge: 0.00,
          finalOtherFee: 0.00,
          finalInterceptFlag: '否',
          finalPayableAmountFormula: '',
          finalInsuranceFee: 0.00,
          finalBrand: '',
          feedback: {
            feedbackType: '',
            belongConfirm: '归属',
            belongBrand: 'Nike',
            belongDivision: '运动事业部',
            handlerDesc: '已与品牌方确认该运单归属Nike运动事业部',
            attachments: ['品牌确认函.pdf'],
            feedbackTime: '2024-07-04 09:00'
          },
          ccUsers: ['张三']
        },
        {
          id: '14',
          diffBillNo: 'CD20240701-014',
          billCycle: '2024-07',
          expressNo: 'SF5555666677',
          transportName: '顺丰快递',
          baozunWeight: 3.0,
          transportWeight: 3.0,
          baozunFee: 45.00,
          transportFee: 45.00,
          diffReason: '退货运单无批次号',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '物流商A',
          createTime: '2024-07-03 16:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['周九']
        },
        {
          id: '15',
          diffBillNo: 'CD20240701-015',
          billCycle: '2024-07',
          expressNo: 'YUNDA7777888899',
          transportName: '韵达快递',
          baozunWeight: 4.0,
          transportWeight: 4.0,
          baozunFee: 55.00,
          transportFee: 60.00,
          diffReason: '标准运费差异',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-04 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['吴十']
        },
        {
          id: '36',
          diffBillNo: 'CD20240701-036',
          billCycle: '2024-07',
          expressNo: 'SF1234567890001',
          transportName: '顺丰速运',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 30.00,
          transportFee: 28.00,
          diffReason: '折后运费差异',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-05 10:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['李四']
        },
        {
          id: '37',
          diffBillNo: 'CD20240701-037',
          billCycle: '2024-07',
          expressNo: 'EMS9876543210001',
          transportName: 'EMS',
          baozunWeight: 1.0,
          transportWeight: 1.0,
          baozunFee: 25.00,
          transportFee: 27.00,
          diffReason: '服务费差异',
          handlerRole: '财务',
          status: '待处理',
          handlerName: '当前用户',
          createTime: '2024-07-05 11:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['张三']
        },
        {
          id: '16',
          diffBillNo: 'CD20240701-016',
          billCycle: '2024-07',
          expressNo: 'DEPPON9999000011',
          transportName: '德邦物流',
          baozunWeight: 20.0,
          transportWeight: 20.0,
          baozunFee: 180.00,
          transportFee: 170.00,
          bzServiceFee: 10.00,
          bzTotalFee: 190.00,
          bzRebate: 5.00,
          transportServiceFee: 8.00,
          transportTotalFee: 178.00,
          transportRebate: 3.00,
          diffReason: '标准运费差异',
          handlerRole: '配送组',
          status: '已处理',
          handlerName: '吴十',
          createTime: '2024-07-01 11:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认物流商费用',
            handlerDesc: '配送记录确认物流商费用正确',
            feedbackTime: '2024-07-02 10:00:00'
          },
          ccUsers: ['张三']
        },
        {
          id: '17',
          diffBillNo: 'CD20240701-017',
          billCycle: '2024-07',
          expressNo: 'SF1234567890',
          transportName: '顺丰快递',
          baozunWeight: 2.5,
          transportWeight: 3.0,
          baozunFee: 35.00,
          transportFee: 40.00,
          diffReason: '计费重量差异',
          handlerRole: '物流商',
          status: '待处理',
          handlerName: '物流商A',
          createTime: '2024-07-05 09:00:00',
          ccFeedbackStatus: '待反馈',
          ccUsers: ['当前用户', '李四'],
          ccPersons: '当前用户, 李四',
          ccTime: '2024-07-05 09:30:00'
        },
        {
          id: '18',
          diffBillNo: 'CD20240701-018',
          billCycle: '2024-07',
          expressNo: 'YTO5555666677',
          transportName: '圆通快递',
          baozunWeight: 1.0,
          transportWeight: 1.0,
          baozunFee: 12.00,
          transportFee: 15.00,
          diffReason: '月结账号差异',
          handlerRole: '财务',
          status: '已处理',
          handlerName: '王五',
          createTime: '2024-07-04 14:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '月结账号已确认无误',
            feedbackTime: '2024-07-05 10:00:00'
          },
          ccUsers: ['当前用户', '周九'],
          ccPersons: '当前用户, 周九',
          ccTime: '2024-07-04 14:30:00',
          ccFeedbacks: [
            {
              ccName: '当前用户',
              ccTime: '2024-07-05 11:30:00',
              ccContent: '已核实，同意财务处理意见。',
              ccAttachments: []
            }
          ]
        },
        {
          id: '19',
          diffBillNo: 'CD20240701-019',
          billCycle: '2024-07',
          expressNo: 'ZTO9999888877',
          transportName: '中通快递',
          baozunWeight: 5.0,
          transportWeight: 5.0,
          baozunFee: 60.00,
          transportFee: 55.00,
          diffReason: '标准运费差异',
          handlerRole: 'KA',
          status: '已处理',
          handlerName: '郑十一',
          createTime: '2024-07-03 10:00:00',
          ccFeedbackStatus: '待反馈',
          checkBrand: '品牌A',
          finalBrand: '品牌B',
          feedback: {
            feedbackType: '确认物流商费用',
            brand: '品牌B',
            isSettle: '结算',
            handlerDesc: '确认品牌归属并同意按物流商费用结算',
            feedbackTime: '2024-07-04 09:00:00'
          },
          ccUsers: ['当前用户', '陈十三'],
          ccPersons: '当前用户, 陈十三',
          ccTime: '2024-07-03 10:30:00'
        },
        {
          id: '20',
          diffBillNo: 'CD20240701-020',
          billCycle: '2024-07',
          expressNo: 'JD9876543210',
          transportName: '京东物流',
          baozunWeight: 8.0,
          transportWeight: 8.0,
          baozunFee: 95.00,
          transportFee: 95.00,
          diffReason: '目的地省差异',
          handlerRole: '运营',
          status: '已关闭',
          handlerName: '刘十四',
          createTime: '2024-07-02 11:00:00',
          ccFeedbackStatus: '已反馈',
          closeReason: '无差异确认',
          closeTime: '2024-07-06 15:00:00',
          closeUser: '张三',
          ccUsers: ['当前用户'],
          ccPersons: '当前用户',
          ccTime: '2024-07-02 11:30:00'
        },
        {
          id: '32',
          diffBillNo: 'CD20240701-032',
          billCycle: '2024-07',
          expressNo: 'SF9876543210003',
          transportName: '顺丰速运',
          baozunWeight: 3.5,
          transportWeight: 3.5,
          baozunFee: 42.00,
          transportFee: 42.00,
          diffReason: '标准运费差异',
          handlerRole: '物流商',
          status: '已处理',
          handlerName: '物流商B',
          createTime: '2024-07-08 10:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '运费计算无误，确认宝尊数据',
            feedbackTime: '2024-07-08 14:30:00'
          },
          ccUsers: ['当前用户'],
          bzBrand: '品牌A'
        },
        {
          id: '33',
          diffBillNo: 'CD20240701-033',
          billCycle: '2024-07',
          expressNo: 'JD9876543210003',
          transportName: '京东物流',
          baozunWeight: 5.0,
          transportWeight: 5.0,
          baozunFee: 58.00,
          transportFee: 58.00,
          diffReason: '计费重量差异',
          handlerRole: '配送组',
          status: '已处理',
          handlerName: '当前用户',
          createTime: '2024-07-08 11:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '已核实重量数据，确认宝尊计费正确',
            feedbackTime: '2024-07-08 15:00:00'
          },
          ccUsers: ['周九'],
          bzBrand: '品牌C'
        },
        {
          id: '34',
          diffBillNo: 'CD20240701-034',
          billCycle: '2024-07',
          expressNo: 'YTO9876543210003',
          transportName: '圆通速递',
          baozunWeight: 2.0,
          transportWeight: 2.0,
          baozunFee: 28.00,
          transportFee: 28.00,
          diffReason: '目的地省差异',
          handlerRole: '财务',
          status: '已处理',
          handlerName: '当前用户',
          createTime: '2024-07-09 09:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '目的地省已确认，按正确地址计费',
            feedbackTime: '2024-07-09 13:30:00'
          },
          ccUsers: ['王五', '李四'],
          bzBrand: '品牌B'
        },
        {
          id: '35',
          diffBillNo: 'CD20240701-035',
          billCycle: '2024-07',
          expressNo: 'ZTO9876543210001',
          transportName: '中通快递',
          baozunWeight: 1.5,
          transportWeight: 1.5,
          baozunFee: 18.00,
          transportFee: 18.00,
          diffReason: '产品类型差异',
          handlerRole: 'IT',
          status: '已处理',
          handlerName: '张小明',
          createTime: '2024-07-09 10:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '产品类型已修正，计费正确',
            feedbackTime: '2024-07-09 14:00:00'
          },
          ccUsers: ['当前用户'],
          bzBrand: '品牌D'
        },
        {
          id: '36',
          diffBillNo: 'CD20240701-036',
          billCycle: '2024-07',
          expressNo: 'SF9876543210004',
          transportName: '顺丰速运',
          baozunWeight: 4.0,
          transportWeight: 4.0,
          baozunFee: 48.00,
          transportFee: 48.00,
          diffReason: '运费未正常计算',
          handlerRole: '配送组',
          status: '已处理',
          handlerName: '当前用户',
          createTime: '2024-07-09 11:00:00',
          ccFeedbackStatus: '已反馈',
          feedback: {
            feedbackType: '确认宝尊费用',
            handlerDesc: '运费已重新计算，数据正确',
            feedbackTime: '2024-07-09 15:30:00'
          },
          ccUsers: ['周九'],
          bzBrand: '品牌A'
        }
      ],
      detailDialogVisible: false,
      detailActiveTab: 'diffDetail',
      interfaceDetails: [
        {
          expressNo: 'SF5192529203170',
          checkResult: '正常',
          billDate: '2024-07',
          pushTime: '2024-07-03 14:30:00',
          batchNo: 'PC202407001',
          remark: '正常',
          monthlyAccount: '8888888888',
          service: '标准快递',
          billingWeight: 1.5,
          senderProvince: '广东省',
          senderCity: '深圳市',
          senderDistrict: '南山区',
          receiverProvince: '北京市',
          receiverCity: '北京市',
          receiverDistrict: '朝阳区',
          firstWeightPrice: 15.00,
          continueWeightPrice: 5.00,
          interceptFlag: '否',
          payableAmountFormula: '(1.5-1)*5+15',
          lightThrowFactor: 0.00,
          actualWeight: 1.5,
          productType: '普通',
          discount: 0.85,
          standardFreight: 17.50,
          discountedFreight: 15.00,
          declaredValue: 0,
          volume: 0.002,
          length: 20,
          width: 10,
          height: 10,
          rebate: 0,
          returnBatchNo: '',
          businessConfirm: '已确认',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        },
        {
          expressNo: 'SF5192529203171',
          checkResult: '差异',
          billDate: '2024-07',
          pushTime: '2024-07-03 10:15:00',
          batchNo: 'PC202407002',
          remark: '重量差异',
          monthlyAccount: '8888888888',
          service: '标准快递',
          billingWeight: 2.0,
          senderProvince: '上海市',
          senderCity: '上海市',
          senderDistrict: '浦东新区',
          receiverProvince: '广东省',
          receiverCity: '广州市',
          receiverDistrict: '天河区',
          firstWeightPrice: 18.00,
          continueWeightPrice: 6.00,
          interceptFlag: '否',
          payableAmountFormula: '(2.0-1)*6+18',
          lightThrowFactor: 0.00,
          actualWeight: 1.5,
          productType: '普通',
          discount: 0.80,
          standardFreight: 24.00,
          discountedFreight: 19.20,
          declaredValue: 0,
          volume: 0.003,
          length: 25,
          width: 15,
          height: 10,
          rebate: 0,
          returnBatchNo: '',
          businessConfirm: '待确认',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        },
        {
          expressNo: 'SF5192529203172',
          checkResult: '正常',
          billDate: '2024-07',
          pushTime: '2024-07-02 16:45:00',
          batchNo: 'PC202407003',
          remark: '正常',
          monthlyAccount: '8888888888',
          service: '特惠快递',
          billingWeight: 0.5,
          senderProvince: '浙江省',
          senderCity: '杭州市',
          senderDistrict: '西湖区',
          receiverProvince: '江苏省',
          receiverCity: '南京市',
          receiverDistrict: '鼓楼区',
          firstWeightPrice: 12.00,
          continueWeightPrice: 4.00,
          interceptFlag: '否',
          payableAmountFormula: '12',
          lightThrowFactor: 0.00,
          actualWeight: 0.5,
          productType: '普通',
          discount: 0.90,
          standardFreight: 12.00,
          discountedFreight: 10.80,
          declaredValue: 0,
          volume: 0.001,
          length: 15,
          width: 10,
          height: 8,
          rebate: 0,
          returnBatchNo: '',
          businessConfirm: '已确认',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        }
      ],
      handleDialogVisible: false,
      auditDialogVisible: false,
      confirmDialogVisible: false,
      rejectDialogVisible: false,
      ccFeedbackDialogVisible: false,
      currentDiff: {},
      handleForm: {
        feedbackType: '',
        confirmedWeight: null,
        actualWeight: null,
        length: null,
        width: null,
        height: null,
        volume: null,
        lightThrowFactor: null,
        senderAddress: [],
        senderProvince: '',
        senderCity: '',
        senderDistrict: '',
        receiverAddress: [],
        receiverProvince: '',
        receiverCity: '',
        receiverDistrict: '',
        firstWeightPrice: null,
        continueWeightPrice: null,
        standardFreight: null,
        discount: '',
        agreementFee11: null,
        agreementFee12: null,
        agreementFee618: null,
        returnFee: null,
        springFee: null,
        specialAreaFee: null,
        otherFee: null,
        serviceFee: null,
        insuranceFee: null,
        interceptFlag: '',
        formula: '',
        productType: '',
        declaredValue: null,
        rebate: null,
        totalFee: null,
        discountedFreight: null,
        monthlyAccount: '',
        remark: '',
        returnBatchNo: '',
        brand: '',
        isSettle: '',
        correctData: '',
        handlerDesc: '',
        attachments: [],
        canDistinguishBrand: '',
        brandAccuracy: '',
        preliminaryBrand: '',
        handleType: '',
        red冲Amount: null,
        forwardReason: '',
        forwardHandlerRole: '',
        forwardHandlerName: '',
        hasBatchNo: '',
        noBatchReason: '',
        belongConfirm: '',
        warehouseCode: '',
        storeCode: ''
      },
      handleSenderAddress: [],
      handleReceiverAddress: [],
      ccFeedbackForm: {
        ccContent: '',
        ccAttachments: []
      },
      rejectForm: {
        reason: ''
      },
      forwardDialogVisible: false,
      forwardForm: {
        handlerRole: '',
        handlerName: '',
        reason: ''
      },
      availableHandlers: [],
      handlerUsers: {
        '物流商': [{ name: '物流商A' }, { name: '物流商B' }, { name: '物流商C' }],
        '财务': [{ name: '张三' }, { name: '李四' }, { name: '王五' }],
        'IT': [{ name: '赵六' }, { name: '钱七' }, { name: '孙八' }],
        '配送组': [{ name: '周九' }, { name: '吴十' }],
        'KA': [{ name: '郑十一' }, { name: '王十二' }],
        '运营': [{ name: '陈十三' }, { name: '刘十四' }]
      },
      batchHandleDialogVisible: false,
      batchHandlerRole: '',
      batchDiffReason: '',
      batchHandleForm: {
        feedbackType: '',
        handlerDesc: ''
      },
      showMyTask: true,
      showMyHandle: true,
      showMyAudit: true,
      showMyCC: true,
      auditForm: {
        feeSource: '系统重算',
        remark: '',
        monthlyAccount: '',
        billingWeight: null,
        actualWeight: null,
        length: null,
        width: null,
        height: null,
        volume: null,
        lightThrowFactor: null,
        senderProvince: '',
        senderCity: '',
        senderDistrict: '',
        receiverProvince: '',
        receiverCity: '',
        receiverDistrict: '',
        firstWeightPrice: null,
        continueWeightPrice: null,
        standardFreight: null,
        discount: '',
        agreementClause11: null,
        agreementClause12: null,
        agreementClause618: null,
        returnFee: null,
        springFestivalService: null,
        specialAreaSurcharge: null,
        otherFee: null,
        interceptFlag: '否',
        payableAmountFormula: '',
        productType: '',
        declaredValue: null,
        totalFee: null,
        calcStandardFreight: null,
        calcDiscountedFreight: null,
        calcServiceFee: null,
        calcTotalFee: null,
        calcRebate: null,
        auditComment: ''
      },
      senderAddress: [],
      receiverAddress: [],
      showAuditPanel: false,
      auditPanelExpanded: true,
      canImport: true,
      showImportDialog: false,
      importUrl: '/api/cost-diff/import',
      importFileList: [],
      importOperation: '处理',
      importResult: null,
      showImportExportResultDialog: false,
      resultFilterForm: {
        operationType: '',
        status: [],
        dateRange: [],
        operator: '',
        operationName: ''
      },
      importExportResultList: [
        { id: 1, operationName: '成本差异处理导入', operationType: '导入', operator: '张三', operationTime: '2024-07-15 14:30:00', status: '成功', resultStatus: '全部成功', successCount: 100, failCount: 0, totalCount: 100 },
        { id: 2, operationName: '差异单列表导出', operationType: '导出', operator: '李四', operationTime: '2024-07-15 10:15:00', status: '成功', resultStatus: '全部成功', successCount: 250, failCount: 0, totalCount: 250 },
        { id: 3, operationName: '成本差异处理导入', operationType: '导入', operator: '王五', operationTime: '2024-07-14 16:45:00', status: '失败', resultStatus: '全部失败', successCount: 0, failCount: 50, totalCount: 50 },
        { id: 4, operationName: '处理结果明细导出', operationType: '导出', operator: '赵六', operationTime: '2024-07-14 09:00:00', status: '成功', resultStatus: '全部成功', successCount: 1500, failCount: 0, totalCount: 1500 },
        { id: 5, operationName: '成本差异处理导入', operationType: '导入', operator: '张三', operationTime: '2024-07-13 11:20:00', status: '成功', resultStatus: '部分成功', successCount: 80, failCount: 20, totalCount: 100 }
      ]
    }
  },
  computed: {
    isAuditor() {
      return this.currentUserRole === '财务'
    },
    isHandler() {
      return ['物流商', '财务', 'IT', '运营', 'KA', '配送组'].includes(this.currentUserRole)
    },
    isCC() {
      return this.currentUserRole === '抄送方'
    },
    isAdmin() {
      return this.currentUserRole === '管理员'
    },
    showBasicColumns() {
      return true
    },
    showHandlerFeedbackColumns() {
      return true
    },
    showAuditColumns() {
      return true
    },
    showRejectReasonColumn() {
      return true
    },
    showCCColumns() {
      return true
    },
    showFinanceColumns() {
      return true
    },
    showBillingWeightColumns() {
      return true
    },
    showTotalFeeColumns() {
      return true
    },
    hasMyCCFeedback() {
      if (!this.currentDiff.ccFeedbacks || this.currentUserRole !== 'CC') return false
      return this.currentDiff.ccFeedbacks.some(cc => cc.ccName === '当前用户')
    },
    myCCFeedback() {
      if (!this.currentDiff.ccFeedbacks) return null
      return this.currentDiff.ccFeedbacks.find(cc => cc.ccName === '当前用户')
    },
    filteredDiffList() {
      if (!this.diffList || !Array.isArray(this.diffList)) {
        return []
      }
      let result = this.diffList.filter(item => item !== null && item !== undefined && item.id)
      
      switch (this.currentView) {
        case 'myTask':
          result = result.filter(item => item.status === '待处理')
          break
        case 'myHandle':
          result = result.filter(item => item.handlerName === '当前用户' && ['已处理', '已驳回', '已关闭'].includes(item.status))
          break
        case 'myAudit':
          result = result.filter(item => item.status === '已处理')
          break
        case 'myCC':
          result = result.filter(item => item.ccUsers && item.ccUsers.includes('当前用户'))
          break
        case 'all':
        default:
          break
      }
      
      return result
    }
  },
  methods: {
    handleSenderAddressChange(val) {
      this.auditForm.senderProvince = val.length > 0 ? val[0] : ''
      this.auditForm.senderCity = val.length > 1 ? val[1] : ''
      this.auditForm.senderDistrict = val.length > 2 ? val[2] : ''
    },
    handleReceiverAddressChange(val) {
      this.auditForm.receiverProvince = val.length > 0 ? val[0] : ''
      this.auditForm.receiverCity = val.length > 1 ? val[1] : ''
      this.auditForm.receiverDistrict = val.length > 2 ? val[2] : ''
    },
    handleSenderAddressChange2(val) {
      this.handleForm.senderProvince = val.length > 0 ? val[0] : ''
      this.handleForm.senderCity = val.length > 1 ? val[1] : ''
      this.handleForm.senderDistrict = val.length > 2 ? val[2] : ''
    },
    handleReceiverAddressChange2(val) {
      this.handleForm.receiverProvince = val.length > 0 ? val[0] : ''
      this.handleForm.receiverCity = val.length > 1 ? val[1] : ''
      this.handleForm.receiverDistrict = val.length > 2 ? val[2] : ''
    },
    handleSelectionChange(val) {
      this.selectedIds = val.map(item => item.id)
    },
    showBatchHandleDialog() {
      const selectedItems = this.diffList.filter(item => this.selectedIds.includes(item.id))
      
      if (selectedItems.length === 0) {
        this.$message.error('请至少选择一条单据')
        return
      }

      const invalidStatusItems = selectedItems.filter(item => item.status !== '待处理' && item.status !== '已驳回')
      if (invalidStatusItems.length > 0) {
        this.$message.error('所选单据中包含状态不为待处理或已驳回的单据，请重新选择')
        return
      }

      const notHandlerItems = selectedItems.filter(item => item.handlerName !== '当前用户')
      if (notHandlerItems.length > 0) {
        this.$message.error(`您不是单据 ${notHandlerItems[0].diffBillNo} 的处理人，无法批量处理`)
        return
      }

      const handlerRoles = [...new Set(selectedItems.map(item => item.handlerRole))]
      if (handlerRoles.length > 1) {
        this.$message.error('所选单据的处理方不一致，请仅选择同一处理方的单据')
        return
      }

      const diffReasons = [...new Set(selectedItems.map(item => item.diffReason))]
      if (diffReasons.length > 1) {
        this.$message.error('所选单据的差异原因不一致，请仅选择相同差异原因的单据')
        return
      }

      this.batchHandlerRole = handlerRoles[0]
      this.batchDiffReason = diffReasons[0]
      this.batchHandleForm = {
        feedbackType: '',
        handlerDesc: ''
      }
      this.batchHandleDialogVisible = true
    },
    submitBatchHandle() {
      if (!this.batchHandleForm.feedbackType) {
        this.$message.error('请选择统一反馈结果类型')
        return
      }

      this.batchHandleDialogVisible = false
      this.$message.success(`批量处理完成，成功处理 ${this.selectedIds.length} 条。`)
      this.selectedIds = []
      this.getDiffList()
    },
    formatCurrency(value) {
      if (value === undefined || value === null) return '0.00'
      return parseFloat(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDiff(value) {
      const sign = value > 0 ? '+' : ''
      return sign + value.toFixed(2)
    },
    getStatusType(status) {
      switch (status) {
        case '待处理':
          return 'warning'
        case '已处理':
          return 'primary'
        case '已驳回':
          return 'danger'
        case '审核通过':
          return 'success'
        case '已关闭':
          return 'info'
        default:
          return 'info'
      }
    },
    handleViewChange(view) {
      console.log('切换视角:', view)
    },
    downloadTemplate() {
      try {
        const XLSX = require('xlsx')
        
        const templateData = [
          {
            '操作类型': '【下拉选择】处理/审核',
            '处理单号': '',
            '处理说明': '',
            '处理方式': '【下拉选择】宝尊费用/物流商费用/其他核对结果/补充退货批次号/以物流商计费重量为准/转发/已配置/确认红冲金额/结算/不结算',
            '是否有批次号': '【下拉选择】有/无',
            '退货批次号': '',
            '无法提供原因': '',
            '计费重量(kg)': '',
            '实际重量(kg)': '',
            '长(cm)': '',
            '宽(cm)': '',
            '高(cm)': '',
            '体积(cm³)': '',
            '轻抛系数': '',
            '寄件省': '',
            '寄件市': '',
            '寄件区': '',
            '收件省': '',
            '收件市': '',
            '收件区': '',
            '首重单价(元)': '',
            '续重单价(元)': '',
            '标准运费(元)': '',
            '折扣/促销': '',
            '协议条款11': '',
            '协议条款12': '',
            '协议条款618': '',
            '退回费': '',
            '春节不打烊': '',
            '特殊地区加价费用': '',
            '其他费用': '',
            '总费用(元)': '',
            '拦截标识': '【下拉选择】是/否',
            '应付金额计算公式': '',
            '产品类型': '',
            '声明价值(元)': '',
            '确认重量(kg)': '',
            '确认长(cm)': '',
            '确认宽(cm)': '',
            '确认高(cm)': '',
            '处理方式-财务': '【下拉选择】确认红冲金额/转发物流商确认/以物流商计费重量为准/转发/宝尊费用/物流商费用/转发KA确认',
            '红冲金额(元)': '',
            '转发处理方': '',
            '转发处理人': '',
            '转发原因': '',
            '运单数据是否可区分品牌': '【下拉选择】可以区分/无法区分',
            '品牌数据准确性': '【下拉选择】准确/不准确',
            '预评品牌': '',
            '是否结算': '【下拉选择】结算/不结算',
            '处理方式-配送': '【下拉选择】已配置/转发',
            '操作类型-IT': '',
            '品牌归属': '',
            '是否结算-KA': '【下拉选择】结算/不结算',
            '归属事业部': '',
            '不归属原因': '',
            '审核结果': '【下拉选择】审核通过/驳回',
            '费用确认来源': '【下拉选择】宝尊费用/物流商费用/系统重算',
            '驳回原因': '',
            '审核意见': '',
            '结算判定': '【下拉选择】结算/不结算',
            '审核-计费重量(kg)': '',
            '审核-实际重量(kg)': '',
            '审核-长(cm)': '',
            '审核-宽(cm)': '',
            '审核-高(cm)': '',
            '审核-体积(cm³)': '',
            '审核-轻抛系数': '',
            '审核-寄件省': '',
            '审核-寄件市': '',
            '审核-寄件区': '',
            '审核-收件省': '',
            '审核-收件市': '',
            '审核-收件区': '',
            '审核-首重单价': '',
            '审核-续重单价': '',
            '审核-标准运费': '',
            '审核-折后运费': '',
            '审核-服务费': '',
            '审核-总费用': '',
            '审核-返利': '',
            '审核-备注': '',
            '审核-月结账号': '',
            '审核-协议条款11': '',
            '审核-协议条款12': '',
            '审核-协议条款618': '',
            '审核-退回费': '',
            '审核-春节不打烊': '',
            '审核-特殊地区加价费用': '',
            '审核-其他费用': '',
            '审核-拦截标识': '【下拉选择】是/否',
            '审核-应付金额计算公式': '',
            '审核-产品类型': '',
            '审核-声明价值': ''
          },
          {
            '操作类型': '专用分类',
            '处理单号': '通用',
            '处理说明': '通用',
            '处理方式': '通用',
            '是否有批次号': '物流商专用',
            '退货批次号': '物流商专用',
            '无法提供原因': '物流商专用',
            '计费重量(kg)': '物流商专用',
            '实际重量(kg)': '物流商专用',
            '长(cm)': '物流商专用',
            '宽(cm)': '物流商专用',
            '高(cm)': '物流商专用',
            '体积(cm³)': '物流商专用',
            '轻抛系数': '物流商专用',
            '寄件省': '物流商专用',
            '寄件市': '物流商专用',
            '寄件区': '物流商专用',
            '收件省': '物流商专用',
            '收件市': '物流商专用',
            '收件区': '物流商专用',
            '首重单价(元)': '物流商专用',
            '续重单价(元)': '物流商专用',
            '标准运费(元)': '物流商专用',
            '折扣/促销': '物流商专用',
            '协议条款11': '物流商专用',
            '协议条款12': '物流商专用',
            '协议条款618': '物流商专用',
            '退回费': '物流商专用',
            '春节不打烊': '物流商专用',
            '特殊地区加价费用': '物流商专用',
            '其他费用': '物流商专用',
            '总费用(元)': '物流商专用',
            '拦截标识': '物流商专用',
            '应付金额计算公式': '物流商专用',
            '产品类型': '物流商专用',
            '声明价值(元)': '物流商专用',
            '确认重量(kg)': '物流商专用',
            '确认长(cm)': '物流商专用',
            '确认宽(cm)': '物流商专用',
            '确认高(cm)': '物流商专用',
            '处理方式-财务': '财务专用',
            '红冲金额(元)': '财务专用',
            '转发处理方': '财务专用',
            '转发处理人': '财务专用',
            '转发原因': '财务专用',
            '运单数据是否可区分品牌': '财务专用',
            '品牌数据准确性': '财务专用',
            '预评品牌': '财务专用',
            '是否结算': '配送组专用',
            '处理方式-配送': '配送组专用',
            '操作类型-IT': 'IT专用',
            '品牌归属': 'KA专用',
            '是否结算-KA': 'KA专用',
            '归属事业部': 'KA专用',
            '不归属原因': 'KA专用',
            '审核结果': '审核操作专用',
            '费用确认来源': '审核操作专用',
            '驳回原因': '审核操作专用',
            '审核意见': '审核操作专用',
            '结算判定': '审核操作专用',
            '审核-计费重量(kg)': '审核操作专用',
            '审核-实际重量(kg)': '审核操作专用',
            '审核-长(cm)': '审核操作专用',
            '审核-宽(cm)': '审核操作专用',
            '审核-高(cm)': '审核操作专用',
            '审核-体积(cm³)': '审核操作专用',
            '审核-轻抛系数': '审核操作专用',
            '审核-寄件省': '审核操作专用',
            '审核-寄件市': '审核操作专用',
            '审核-寄件区': '审核操作专用',
            '审核-收件省': '审核操作专用',
            '审核-收件市': '审核操作专用',
            '审核-收件区': '审核操作专用',
            '审核-首重单价': '审核操作专用',
            '审核-续重单价': '审核操作专用',
            '审核-标准运费': '审核操作专用',
            '审核-折后运费': '审核操作专用',
            '审核-服务费': '审核操作专用',
            '审核-总费用': '审核操作专用',
            '审核-返利': '审核操作专用',
            '审核-备注': '审核操作专用',
            '审核-月结账号': '审核操作专用',
            '审核-协议条款11': '审核操作专用',
            '审核-协议条款12': '审核操作专用',
            '审核-协议条款618': '审核操作专用',
            '审核-退回费': '审核操作专用',
            '审核-春节不打烊': '审核操作专用',
            '审核-特殊地区加价费用': '审核操作专用',
            '审核-其他费用': '审核操作专用',
            '审核-拦截标识': '审核操作专用',
            '审核-应付金额计算公式': '审核操作专用',
            '审核-产品类型': '审核操作专用',
            '审核-声明价值': '审核操作专用'
          },
          {
            '操作类型': '处理',
            '处理单号': 'CD20240701-002',
            '处理说明': '确认费用无误',
            '处理方式': '宝尊费用',
            '是否有批次号': '',
            '退货批次号': '',
            '无法提供原因': '',
            '计费重量(kg)': '',
            '实际重量(kg)': '',
            '长(cm)': '',
            '宽(cm)': '',
            '高(cm)': '',
            '体积(cm³)': '',
            '轻抛系数': '',
            '寄件省': '',
            '寄件市': '',
            '寄件区': '',
            '收件省': '',
            '收件市': '',
            '收件区': '',
            '首重单价(元)': '',
            '续重单价(元)': '',
            '标准运费(元)': '',
            '折扣/促销': '',
            '协议条款11': '',
            '协议条款12': '',
            '协议条款618': '',
            '退回费': '',
            '春节不打烊': '',
            '特殊地区加价费用': '',
            '其他费用': '',
            '总费用(元)': '',
            '拦截标识': '',
            '应付金额计算公式': '',
            '产品类型': '',
            '声明价值(元)': '',
            '确认重量(kg)': '',
            '确认长(cm)': '',
            '确认宽(cm)': '',
            '确认高(cm)': '',
            '处理方式-财务': '',
            '红冲金额(元)': '',
            '转发处理方': '',
            '转发处理人': '',
            '转发原因': '',
            '运单数据是否可区分品牌': '',
            '品牌数据准确性': '',
            '预评品牌': '',
            '是否结算': '',
            '处理方式-配送': '',
            '操作类型-IT': '',
            '品牌归属': '',
            '是否结算-KA': '',
            '归属事业部': '',
            '不归属原因': '',
            '审核结果': '',
            '费用确认来源': '',
            '驳回原因': '',
            '审核意见': '',
            '结算判定': '',
            '审核-计费重量(kg)': '',
            '审核-实际重量(kg)': '',
            '审核-长(cm)': '',
            '审核-宽(cm)': '',
            '审核-高(cm)': '',
            '审核-体积(cm³)': '',
            '审核-轻抛系数': '',
            '审核-寄件省': '',
            '审核-寄件市': '',
            '审核-寄件区': '',
            '审核-收件省': '',
            '审核-收件市': '',
            '审核-收件区': '',
            '审核-首重单价': '',
            '审核-续重单价': '',
            '审核-标准运费': '',
            '审核-折后运费': '',
            '审核-服务费': '',
            '审核-总费用': '',
            '审核-返利': '',
            '审核-备注': '',
            '审核-月结账号': '',
            '审核-协议条款11': '',
            '审核-协议条款12': '',
            '审核-协议条款618': '',
            '审核-退回费': '',
            '审核-春节不打烊': '',
            '审核-特殊地区加价费用': '',
            '审核-其他费用': '',
            '审核-拦截标识': '',
            '审核-应付金额计算公式': '',
            '审核-产品类型': '',
            '审核-声明价值': ''
          },
          {
            '操作类型': '审核',
            '处理单号': 'CD20240701-003',
            '处理说明': '',
            '处理方式': '',
            '是否有批次号': '',
            '退货批次号': '',
            '无法提供原因': '',
            '计费重量(kg)': '',
            '实际重量(kg)': '',
            '长(cm)': '',
            '宽(cm)': '',
            '高(cm)': '',
            '体积(cm³)': '',
            '轻抛系数': '',
            '寄件省': '',
            '寄件市': '',
            '寄件区': '',
            '收件省': '',
            '收件市': '',
            '收件区': '',
            '首重单价(元)': '',
            '续重单价(元)': '',
            '标准运费(元)': '',
            '折扣/促销': '',
            '协议条款11': '',
            '协议条款12': '',
            '协议条款618': '',
            '退回费': '',
            '春节不打烊': '',
            '特殊地区加价费用': '',
            '其他费用': '',
            '总费用(元)': '',
            '拦截标识': '',
            '应付金额计算公式': '',
            '产品类型': '',
            '声明价值(元)': '',
            '确认重量(kg)': '',
            '确认长(cm)': '',
            '确认宽(cm)': '',
            '确认高(cm)': '',
            '处理方式-财务': '',
            '红冲金额(元)': '',
            '转发处理方': '',
            '转发处理人': '',
            '转发原因': '',
            '运单数据是否可区分品牌': '',
            '品牌数据准确性': '',
            '预评品牌': '',
            '是否结算': '',
            '处理方式-配送': '',
            '操作类型-IT': '',
            '品牌归属': '',
            '是否结算-KA': '',
            '归属事业部': '',
            '不归属原因': '',
            '审核结果': '审核通过',
            '费用确认来源': '宝尊费用',
            '驳回原因': '',
            '审核意见': '审核通过，无异议',
            '结算判定': '',
            '审核-计费重量(kg)': '',
            '审核-实际重量(kg)': '',
            '审核-长(cm)': '',
            '审核-宽(cm)': '',
            '审核-高(cm)': '',
            '审核-体积(cm³)': '',
            '审核-轻抛系数': '',
            '审核-寄件省': '',
            '审核-寄件市': '',
            '审核-寄件区': '',
            '审核-收件省': '',
            '审核-收件市': '',
            '审核-收件区': '',
            '审核-首重单价': '',
            '审核-续重单价': '',
            '审核-标准运费': '',
            '审核-折后运费': '',
            '审核-服务费': '',
            '审核-总费用': '',
            '审核-返利': '',
            '审核-备注': '',
            '审核-月结账号': '',
            '审核-协议条款11': '',
            '审核-协议条款12': '',
            '审核-协议条款618': '',
            '审核-退回费': '',
            '审核-春节不打烊': '',
            '审核-特殊地区加价费用': '',
            '审核-其他费用': '',
            '审核-拦截标识': '',
            '审核-应付金额计算公式': '',
            '审核-产品类型': '',
            '审核-声明价值': ''
          }
        ]
        
        const worksheet = XLSX.utils.json_to_sheet(templateData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, '处理结果')
        
        const colWidths = [
          { wch: 18 }, { wch: 20 }, { wch: 20 }, { wch: 35 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
          { wch: 15 }, { wch: 15 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 12 },
          { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
          { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 },
          { wch: 18 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
          { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
          { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
          { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 15 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 18 },
          { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
          { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 15 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
          { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
        ]
        worksheet['!cols'] = colWidths
        
        XLSX.writeFile(workbook, '成本差异处理导入模板.xlsx')
        
        this.$message.success('模板下载成功')
      } catch (error) {
        console.error('下载模板失败:', error)
        this.$message.error('下载模板失败，请稍后重试')
      }
    },
    beforeImportUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      file.type === 'application/vnd.ms-excel'
      if (!isExcel) {
        this.$message.error('文件格式不正确，请上传 .xlsx 或 .xls 文件')
        return false
      }
      return true
    },
    handleImportSuccess(response) {
      if (response.success) {
        this.importResult = {
          type: 'success',
          message: `全部导入成功，共处理 ${response.count} 条。`,
          hasErrorFile: false
        }
      } else {
        this.importResult = {
          type: 'error',
          message: response.message || '导入失败，请下载错误明细查看详情',
          hasErrorFile: response.hasErrorFile || false
        }
      }
      this.getDiffList()
    },
    handleImportError() {
      this.importResult = {
        type: 'error',
        message: '导入执行失败，已全部回滚，请重试',
        hasErrorFile: false
      }
    },
    submitImport() {
      if (this.importFileList.length === 0) {
        this.$message.warning('请先选择要导入的文件')
        return
      }
      this.importResult = null
      this.$refs.importUpload.submit()
    },
    downloadErrorFile() {
      window.location.href = '/api/cost-diff/import/error-file'
    },
    goToImportExportResult() {
      const path = '/import-export-result'
      if (this.$root && this.$root.tabs) {
        const existingTab = this.$root.tabs.find(tab => tab.path === path)
        if (!existingTab) {
          this.$root.tabs.push({ label: '导入导出结果', path: path })
        }
        this.$root.activeTab = path
      }
      this.$router.push({ path: path }).catch(err => {
        console.log('路由跳转错误:', err)
      })
    },
    handleSearchResult() {
      console.log('搜索导入导出结果:', this.resultFilterForm)
    },
    resetResultFilter() {
      this.resultFilterForm = {
        operationType: '',
        status: [],
        dateRange: [],
        operator: '',
        operationName: ''
      }
    },
    getStatusType(status) {
      const typeMap = {
        '成功': 'success',
        '失败': 'danger',
        '处理中': 'warning',
        '已取消': 'info'
      }
      return typeMap[status] || 'info'
    },
    downloadResult(row) {
      window.location.href = `/api/import-export/download/${row.id}`
    },
    viewResultDetail(row) {
      this.$message.info(`查看详情：${row.operationName}`)
    },
    deleteResult(row) {
      this.$confirm(`确认删除操作记录"${row.operationName}"？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.importExportResultList = this.importExportResultList.filter(item => item.id !== row.id)
        this.$message.success('删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    retryImport(row) {
      this.$message.info(`重新导入：${row.operationName}`)
    },
    initViewTabs() {
      if (this.currentUserRole === '管理员') {
        this.showMyTask = true
        this.showMyHandle = true
        this.showMyAudit = true
        this.showMyCC = true
        this.currentView = 'all'
      } else if (this.currentUserRole === '处理人') {
        this.showMyTask = true
        this.showMyHandle = true
        this.showMyAudit = true
        this.showMyCC = true
        this.currentView = 'myTask'
      } else if (this.currentUserRole === '财务' || this.currentUserRole === '审核人') {
        this.showMyTask = true
        this.showMyHandle = true
        this.showMyAudit = true
        this.showMyCC = true
        this.currentView = 'myAudit' // 审核人默认进入"我审核的"页签
      } else if (this.currentUserRole === '抄送方') {
        this.showMyTask = true
        this.showMyHandle = true
        this.showMyAudit = true
        this.showMyCC = true
        this.currentView = 'myCC'
      } else {
        this.showMyTask = true
        this.showMyHandle = true
        this.showMyAudit = true
        this.showMyCC = true
        this.currentView = 'myTask'
      }
    },
    canHandle(row) {
      if (!row) return false
      const canHandleStatus = ['待处理', '已驳回']
      if (!canHandleStatus.includes(row.status)) return false
      if (row.handlerName && row.handlerName === '当前用户') return true
      if (row.handlerRole === this.currentUserRole) return true
      return false
    },
    canAudit(row) {
      if (!row) return false
      return row.status === '已处理' && this.currentUserRole === '财务'
    },
    canForward(row) {
      if (!row) return false
      if (row.status === '已关闭') return false
      if (this.currentUserRole === '财务' && row.status === '待处理') return true
      if (row.status === '待处理') return true
      return false
    },
    isCcUser(row) {
      if (!row.ccUsers || !Array.isArray(row.ccUsers)) return false
      return row.ccUsers.includes('当前用户')
    },
    handleSearch() {
      console.log('搜索:', this.filterForm)
      this.performSearch()
    },
    performSearch() {
      let filtered = this.originalDiffList || this.diffList
      
      if (this.filterForm.billCycle) {
        filtered = filtered.filter(item => item.billCycle === this.filterForm.billCycle)
      }
      
      if (this.filterForm.expressNo) {
        const expressNos = this.filterForm.expressNo.split(/[,，\s]+/).filter(n => n.trim())
        filtered = filtered.filter(item => expressNos.some(no => item.expressNo.includes(no.trim())))
      }
      
      if (this.filterForm.diffBillNo) {
        const billNos = this.filterForm.diffBillNo.split(/[,，\s]+/).filter(n => n.trim())
        filtered = filtered.filter(item => billNos.some(no => item.diffBillNo.includes(no.trim())))
      }
      
      if (this.filterForm.handlerRole && this.filterForm.handlerRole.length > 0) {
        filtered = filtered.filter(item => this.filterForm.handlerRole.includes(item.handlerRole))
      }
      
      if (this.filterForm.diffReason && this.filterForm.diffReason.length > 0) {
        filtered = filtered.filter(item => this.filterForm.diffReason.includes(item.diffReason))
      }
      
      if (this.filterForm.status && this.filterForm.status.length > 0) {
        filtered = filtered.filter(item => this.filterForm.status.includes(item.status))
      }
      
      if (this.filterForm.transportName && this.filterForm.transportName.length > 0) {
        filtered = filtered.filter(item => this.filterForm.transportName.includes(item.transportName))
      }
      
      if (this.filterForm.companyName) {
        filtered = filtered.filter(item => item.companyName && item.companyName.includes(this.filterForm.companyName))
      }
      
      this.diffList = filtered
      this.tableData = filtered.slice(0, this.pagination.pageSize)
      this.pagination.total = filtered.length
      this.pagination.currentPage = 1
    },
    handleImport() {
      this.$message.info('导入功能开发中')
    },
    handleExport() {
      this.exportLoading = true
      const params = {
        ...this.filterForm,
        pageNum: 1,
        pageSize: 99999
      }
      this.$axios.post('/api/cost-diff/export', params).then(res => {
        if (res.data.success) {
          this.$message.success('导出任务已提交，请在导入导出结果中查看进度')
        } else {
          this.$message.error('导出任务提交失败：' + res.data.message)
        }
        this.exportLoading = false
      }).catch(err => {
        this.$message.error('导出任务提交失败')
        this.exportLoading = false
      })
    },
    handleReset() {
      this.filterForm = {
        billCycle: '',
        expressNo: '',
        diffBillNo: '',
        handlerRole: [],
        diffReason: [],
        status: [],
        transportName: '',
        ccStatus: ''
      }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current
    },
    goDetail(row, fromFeedback = false) {
      this.$router.push({
        path: '/cost-diff-detail',
        query: {
          fromFeedback: fromFeedback ? 'true' : 'false',
          status: row.status,
          diffReason: row.diffReason,
          diffBillNo: row.diffBillNo,
          handlerRole: row.handlerRole,
          fromView: this.currentView
        }
      })
    },
    handleDiff(row) {
      this.currentDiff = row
      let defaultFeedbackType = ''
      if (row.handlerRole === '财务' && row.diffReason === '计费重量差异') {
        defaultFeedbackType = '以物流商计费重量为准'
      } else if (row.handlerRole === 'IT') {
        defaultFeedbackType = '重新调用接口并重算'
      } else if (row.handlerRole === '财务' && row.diffReason === '结算系统不存在' && row.systemBrandDetermined) {
        defaultFeedbackType = '确认品牌'
      } else if (row.handlerRole === '配送组' && (row.diffReason === '运费未正常计算' || row.diffReason === '首重报价差异' || row.diffReason === '续重报价差异')) {
        defaultFeedbackType = '重新计算'
      } else if (row.handlerRole === '财务' && row.diffReason === '运单卡接口') {
        defaultFeedbackType = '重新下发'
      }
      this.handleForm = {
        feedbackType: defaultFeedbackType,
        confirmedWeight: null,
        length: null,
        width: null,
        height: null,
        returnBatchNo: '',
        brand: '',
        isSettle: '',
        correctData: '',
        handlerDesc: '',
        attachments: [],
        handleType: '',
        red冲Amount: row.red冲Amount || null,
        forwardReason: '',
        belongConfirm: '',
        warehouseCode: '',
        storeCode: ''
      }
      this.handleDialogVisible = true
    },
    auditDiff(row) {
      this.$router.push(`/cost-diff-detail?diffBillNo=${row.diffBillNo}&mode=audit&diffReason=${encodeURIComponent(row.diffReason)}&status=${encodeURIComponent(row.status)}&handlerRole=${encodeURIComponent(row.handlerRole)}`)
    },
    toggleAuditPanel() {
      this.auditPanelExpanded = !this.auditPanelExpanded
    },
    closeAuditPanel() {
      this.showAuditPanel = false
      this.auditPanelExpanded = true
    },
    recalculateAudit() {
      this.$message.info('正在重新计算费用...')
      setTimeout(() => {
        this.auditForm.calcStandardFreight = Math.round((Math.random() * 50 + 10) * 100) / 100
        this.auditForm.calcDiscountedFreight = Math.round((this.auditForm.calcStandardFreight * 0.9) * 100) / 100
        this.auditForm.calcServiceFee = Math.round((Math.random() * 5 + 1) * 100) / 100
        this.auditForm.calcTotalFee = Math.round((this.auditForm.calcDiscountedFreight + this.auditForm.calcServiceFee) * 100) / 100
        this.auditForm.calcRebate = Math.round((Math.random() * 2) * 100) / 100
        this.$message.success('费用重新计算完成')
      }, 500)
    },
    onFeeSourceChange(val) {
      if (val === '宝尊费用') {
        this.auditForm.calcStandardFreight = this.currentDiff.bzFee || 0
        this.auditForm.calcDiscountedFreight = this.currentDiff.bzFee ? Math.round(this.currentDiff.bzFee * 0.9 * 100) / 100 : 0
        this.auditForm.calcServiceFee = this.currentDiff.bzServiceFee || 0
        this.auditForm.calcTotalFee = this.currentDiff.bzTotalFee || 0
        this.auditForm.calcRebate = this.currentDiff.bzRebate || 0
      } else if (val === '物流商费用') {
        this.auditForm.calcStandardFreight = this.currentDiff.transportFee || 0
        this.auditForm.calcDiscountedFreight = this.currentDiff.transportFee ? Math.round(this.currentDiff.transportFee * 0.95 * 100) / 100 : 0
        this.auditForm.calcServiceFee = this.currentDiff.transportServiceFee || 0
        this.auditForm.calcTotalFee = this.currentDiff.transportTotalFee || 0
        this.auditForm.calcRebate = this.currentDiff.transportRebate || 0
      } else if (val === '系统重算') {
        this.recalculateAudit()
      }
    },
    confirmDiff(row) {
      this.currentDiff = row
      this.confirmDialogVisible = true
    },
    showCCFeedbackDialog() {
      this.ccFeedbackForm = {
        ccContent: this.myCCFeedback ? this.myCCFeedback.ccContent : '',
        ccAttachments: this.myCCFeedback ? this.myCCFeedback.ccAttachments : []
      }
      this.ccFeedbackDialogVisible = true
    },
    submitCCFeedback() {
      this.ccFeedbackDialogVisible = false
      this.$message.success('抄送反馈提交成功')
    },
    onFeedbackTypeChange() {
      if (this.handleForm.feedbackType !== '其他核对结果') {
        this.handleForm.confirmedWeight = null
        this.handleForm.length = null
        this.handleForm.width = null
        this.handleForm.height = null
      }
      if (this.handleForm.feedbackType !== '补充退货批次号') {
        this.handleForm.returnBatchNo = ''
      }
    },
    beforeUpload(file) {
      const isAllowed = ['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)
      if (!isAllowed) {
        this.$message.error('仅支持jpg/png/pdf/excel格式')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }
      return true
    },
    submitHandle() {
      if (this.currentDiff.handlerRole === '物流商' && this.currentDiff.diffReason === '退货运单无批次号') {
        if (!this.handleForm.feedbackType) {
          this.$message.error('请选择核对结果')
          return
        }
        if (this.handleForm.feedbackType === '补充退货批次号' && !this.handleForm.returnBatchNo) {
          this.$message.error('请输入退货批次号')
          return
        }
        if (this.handleForm.feedbackType === '补充退货批次号') {
          this.$message.success(`补充退货批次号成功：${this.handleForm.returnBatchNo}，将触发重新匹配`)
        } else {
          this.$message.success('处理完成，处理单已流转至财务审核')
        }
        this.handleDialogVisible = false
        return
      }
      if (this.currentDiff.handlerRole === '财务' && this.currentDiff.diffReason === '运单卡接口') {
        this.$message.info('正在尝试重新下发运单接口数据，请稍后刷新页面查看结果。')
        this.handleDialogVisible = false
        return
      }
      if (this.currentDiff.handlerRole === '配送组' && this.currentDiff.diffReason === '运费未正常计算') {
        this.$message.info('系统正在重新计算运费，请在数分钟后刷新页面查看结果。')
        this.handleDialogVisible = false
        return
      }
      if (this.currentDiff.handlerRole === '物流商' && !this.handleForm.feedbackType) {
        this.$message.error('请选择核对结果')
        return
      }
      if (this.handleForm.feedbackType === '其他核对结果' && !this.handleForm.confirmedWeight) {
        this.$message.error('请输入确认重量')
        return
      }
      if (this.handleForm.feedbackType === '补充退货批次号' && !this.handleForm.returnBatchNo) {
        this.$message.error('请输入退货批次号')
        return
      }
      if (this.currentDiff.handlerRole === 'KA' &&
        (this.currentDiff.diffReason === '结算系统不存在' || this.currentDiff.diffReason === '退货运单仅登记')) {
        if (!this.handleForm.belongConfirm) {
          this.$message.error('请选择核对结果')
          return
        }
        if (!this.handleForm.warehouseCode) {
          this.$message.error('请选择仓库')
          return
        }
        if (!this.handleForm.storeCode) {
          this.$message.error('请选择店铺')
          return
        }
      } else if (this.currentDiff.handlerRole === 'KA') {
        if (!this.handleForm.brand) {
          this.$message.error('请选择品牌归属')
          return
        }
        if (!this.handleForm.isSettle) {
          this.$message.error('请选择是否结算')
          return
        }
      }
      if (this.currentDiff.handlerRole === '财务' && this.currentDiff.diffReason === '红冲运单') {
        if (!this.handleForm.handleType) {
          this.$message.error('请选择处理方式')
          return
        }
        if (this.handleForm.handleType === '确认红冲金额') {
          if (!this.handleForm.red冲Amount || this.handleForm.red冲Amount < 0) {
            this.$message.error('请输入有效的红冲金额（必须大于等于0）')
            return
          }
          this.$message.success(`确认红冲金额成功，金额：${this.handleForm.red冲Amount.toFixed(2)}元，差异单已直接关闭`)
        } else if (this.handleForm.handleType === '转发物流商确认') {
          if (!this.handleForm.forwardReason || !this.handleForm.forwardReason.trim()) {
            this.$message.error('请填写转发原因')
            return
          }
          this.$message.success('已转发物流商确认，原处理单已关闭，新处理单已生成')
        }
        this.handleDialogVisible = false
        return
      }
      if (this.currentDiff.handlerRole === '配送组' && this.currentDiff.diffReason === '非宝尊月结') {
        if (!this.handleForm.isSettle) {
          this.$message.error('请选择是否结算')
          return
        }
        if (this.handleForm.isSettle === '结算') {
          const hasMonthlyAccount = this.currentDiff.monthlyAccount && this.currentDiff.monthlyAccount.trim() !== ''
          if (!hasMonthlyAccount) {
            this.$message.error('月结账号未维护，不允许处理！')
            return
          }
          this.$message.success('月结账号校验通过，提交成功，将进行重新匹配')
        } else {
          this.$message.success('确认不结算，原差异单已关闭，新差异单已生成用于推送物流商')
        }
        this.handleDialogVisible = false
        return
      }
      this.handleDialogVisible = false
      this.$message.success('处理成功')
    },
    passAudit() {
      this.showAuditPanel = false
      this.$message.success('审核通过')
    },
    rejectDiff() {
      this.rejectForm.reason = ''
      this.rejectDialogVisible = true
    },
    showForwardDialog(row) {
      this.currentDiff = row
      this.forwardForm = {
        handlerRole: row.handlerRole || '',
        handlerName: row.handlerName || '',
        reason: ''
      }
      this.availableHandlers = this.handlerUsers[row.handlerRole] || []
      this.forwardDialogVisible = true
    },
    onHandlerRoleChange() {
      this.availableHandlers = this.handlerUsers[this.forwardForm.handlerRole] || []
      this.forwardForm.handlerName = ''
    },
    handleForward() {
      if (!this.forwardForm.handlerRole) {
        this.$message.error('请选择处理方')
        return
      }
      if (!this.forwardForm.handlerName) {
        this.$message.error('请选择处理人')
        return
      }
      const originalHandlerRole = this.currentDiff.handlerRole
      const originalHandlerName = this.currentDiff.handlerName
      const isRoleChanged = originalHandlerRole !== this.forwardForm.handlerRole
      if (isRoleChanged && this.currentUserRole === '财务') {
        this.$confirm('变更处理方将生成新的差异处理单据，原处理流程中的反馈将被保留但不再生效。确认继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doForward(isRoleChanged, originalHandlerRole, originalHandlerName)
        }).catch(() => {
          // 用户取消
        })
      } else {
        this.doForward(isRoleChanged, originalHandlerRole, originalHandlerName)
      }
    },
    doForward(isRoleChanged, originalHandlerRole, originalHandlerName) {
      this.forwardDialogVisible = false
      if (isRoleChanged) {
        this.$message.success(`转发成功：原处理方[${originalHandlerRole}]/原处理人[${originalHandlerName}] → 新处理方[${this.forwardForm.handlerRole}]/新处理人[${this.forwardForm.handlerName}]，已生成新处理单`)
      } else {
        this.$message.success(`转发成功：处理人已更新为[${this.forwardForm.handlerName}]`)
      }
    },
    submitReject() {
      if (!this.rejectForm.reason) {
        this.$message.error('请输入驳回原因')
        return
      }
      this.rejectDialogVisible = false
      this.auditDialogVisible = false
      this.$message.success('驳回成功')
    },
    confirmClose() {
      this.confirmDialogVisible = false
      this.$message.success('已关闭差异单')
    },
    openSyncDialog() {
      this.loadSyncData()
      this.showSyncDialog = true
    },
    loadSyncData() {
      // 模拟从服务器获取待同步数据
      this.syncLogisticsList = [
        {
          transportName: '顺丰快递',
          count: 25,
          apiUrl: 'https://api.sf-express.com/v2/diff/push',
          isApi: true
        },
        {
          transportName: '京东物流',
          count: 18,
          apiUrl: 'https://api.jd.com/logistics/diff',
          isApi: true
        },
        {
          transportName: '圆通速递',
          count: 0,
          apiUrl: '—（导入处理，跳过）',
          isApi: false
        }
      ]
      this.totalSyncCount = this.syncLogisticsList.reduce((sum, item) => sum + item.count, 0)
      
      if (this.totalSyncCount === 0) {
        this.$message.warning('当前没有可通过接口同步的待处理单据')
      }
    },
    startSync() {
      if (this.totalSyncCount === 0) {
        this.$message.warning('没有可同步的单据')
        return
      }
      
      this.syncLoading = true
      
      // 模拟异步同步过程
      setTimeout(() => {
        const now = new Date()
        const timeStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
        
        // 添加同步记录到导入导出结果列表
        this.importExportResultList.unshift({
          id: Date.now(),
          operationName: `同步物流商 - ${timeStr}`,
          operationType: '同步物流商',
          operator: '当前用户',
          operationTime: timeStr,
          status: '处理中',
          resultStatus: '处理中',
          successCount: 0,
          failCount: 0,
          totalCount: this.totalSyncCount
        })
        
        // 模拟同步完成
        setTimeout(() => {
          this.syncLoading = false
          this.showSyncDialog = false
          
          // 更新第一条记录的状态
          this.importExportResultList[0].status = '成功'
          this.importExportResultList[0].resultStatus = '全部成功'
          this.importExportResultList[0].successCount = this.totalSyncCount
          
          this.$message.success(`同步任务已提交，共 ${this.totalSyncCount} 条，请在导入导出结果中查看进度。`)
        }, 2000)
      }, 500)
    },
    saveSettings() {
      this.showSettingsDialog = false
      this.pagination.pageSize = this.settingsForm.pageSize
      this.$message.success('设置已保存')
    }
  },
  mounted() {
    this.initViewTabs()
    this.originalDiffList = [...this.diffList]
  }
}
</script>

<style scoped>
.cost-diff-handle-page {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 48px);
}

.sync-dialog-content {
  padding: 8px 0;
}

.sync-desc {
  font-size: 14px;
  color: #606266;
  margin-bottom: 16px;
}

.sync-table-wrapper {
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.sync-summary {
  margin: 16px 0;
  padding: 12px;
  background-color: #f0f9ff;
  border-left: 4px solid #409EFF;
  border-radius: 4px;
}

.sync-summary p {
  margin: 0;
  font-size: 14px;
  color: #409EFF;
}

.sync-notice {
  padding: 12px;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
}

.sync-notice p {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #F56C6C;
}

.sync-notice ul {
  margin: 0;
  padding-left: 20px;
}

.sync-notice li {
  margin: 4px 0;
  font-size: 13px;
  color: #F56C6C;
}

.settings-btn {
  margin-left: 8px;
  padding: 0 12px;
}

.settings-content {
  padding: 8px 0;
}

.view-tabs-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #fff;
  min-height: 44px;
  width: 100%;
}

.view-tabs-bar .tabs-wrapper {
  display: inline-flex;
  align-items: center;
  height: 44px;
}

.view-tabs-bar .tabs-wrapper .el-radio-group {
  display: inline-flex;
  align-items: center;
  height: 100%;
}

.view-tabs-bar .tabs-wrapper .el-radio-button {
  height: 44px;
  line-height: 44px;
}

.view-tabs-bar .buttons-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-right: 12px;
}

.filter-area {
  background-color: #fff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.batch-actions {
  padding: 12px 0;
  margin-bottom: 8px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;
}

.filter-form .el-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

.filter-form .el-form-item__label {
  font-size: 13px;
  color: #606266;
  min-width: 80px;
  text-align: right;
  padding-right: 8px;
}

.filter-form .el-form-item__content {
  display: flex;
  align-items: center;
}

.filter-form .el-date-editor,
.filter-form .el-input,
.filter-form .el-select {
  height: 32px;
}

.filter-form .el-input__inner,
.filter-form .el-select__input {
  height: 32px;
  line-height: 32px;
}

.filter-form .el-select .el-input.is-focus .el-input__inner {
  height: 32px;
}

.filter-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 16px;
  border-left: 1px solid #e4e7ed;
}

.diff-list-area {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.diff-list-area .el-table {
  font-size: 13px;
}

.diff-list-area .el-table th {
  background-color: #fafafa;
  font-weight: 500;
  color: #606266;
}

.action-link {
  color: #409EFF;
}

.pagination-area {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid #ebeef5;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h3 {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 14px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
}

.info-label {
  color: #606266;
}

.info-value {
  color: #303133;
}

.compare-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.compare-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
}

.compare-label {
  color: #606266;
}

.compare-value {
  color: #303133;
  font-weight: 500;
}

.compare-value.diff {
  color: #F56C6C;
}

.feedback-content {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
}

.feedback-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px dashed #e4e7ed;
}

.feedback-item:last-child {
  border-bottom: none;
}

.feedback-label {
  color: #606266;
  width: 120px;
}

.feedback-value {
  color: #303133;
  flex: 1;
  text-align: right;
}

.cc-feedback-section {
  background-color: #fffbe6;
  padding: 14px;
  border-radius: 4px;
  border: 1px solid #ffe58f;
}

.cc-feedback-section h3,
.cc-feedback-section h4 {
  color: #d48806;
}

.cc-feedback-list {
  margin-top: 10px;
}

.cc-feedback-item {
  background-color: #fff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  border: 1px solid #ffd591;
}

.cc-feedback-item:last-child {
  margin-bottom: 0;
}

.cc-feedback-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.cc-name {
  font-weight: 500;
  color: #d48806;
}

.cc-time {
  color: #999;
  font-size: 12px;
}

.cc-content p {
  margin: 4px 0;
  font-size: 13px;
  color: #606266;
}

.attachment-link {
  color: #409EFF;
  margin-right: 8px;
  cursor: pointer;
}

.my-cc-feedback {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
}

.no-feedback {
  color: #909399;
  margin-bottom: 12px;
}

.my-feedback-content {
  margin-bottom: 12px;
}

.my-feedback-content p {
  margin: 4px 0;
  font-size: 13px;
}

.handle-form {
  padding: 10px;
}

.reject-record {
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  padding: 14px;
  margin-bottom: 16px;
}

.reject-record-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f56c6c;
  font-weight: 600;
  margin-bottom: 12px;
  font-size: 14px;
}

.reject-record-title i {
  font-size: 16px;
}

.reject-record-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reject-record-item {
  display: flex;
  font-size: 13px;
  line-height: 1.6;
}

.reject-label {
  color: #909399;
  min-width: 70px;
}

.reject-value {
  color: #303133;
  flex: 1;
}

.form-section h4 {
  font-size: 13px;
  color: #409EFF;
  margin-bottom: 16px;
}

.it-handle {
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.it-handle p {
  margin-bottom: 14px;
  font-size: 13px;
  color: #606266;
}

.correct-section {
  padding: 14px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.correct-section p {
  margin-bottom: 10px;
  font-size: 13px;
  color: #606266;
}

.audit-form {
  padding: 10px;
}

.audit-section h4 {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 14px;
}

.audit-section.cc-feedback-section h4 {
  color: #d48806;
}

.audit-info {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
}

.audit-info p {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}

.cc-feedback-done {
  color: #67C23A;
  font-weight: 500;
}

.cc-feedback-pending {
  color: #E6A23C;
  font-weight: 500;
}

.upload-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.audit-panel {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  overflow: hidden;
}

.audit-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  cursor: pointer;
}

.audit-panel .panel-header h3 {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin: 0;
}

.audit-panel .panel-content {
  padding: 16px;
}

.audit-panel .panel-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e4e7ed;
  background-color: #fafafa;
}

.form-section-title {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.handle-form .summary-info {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.handle-form .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px dashed #e4e7ed;
}

.handle-form .summary-row:last-child {
  border-bottom: none;
}

.handle-form .summary-label {
  color: #606266;
  width: 80px;
}

.handle-form .summary-value {
  color: #303133;
  flex: 1;
  text-align: right;
  font-weight: 500;
}

.finance-handle-section {
  padding: 10px;
}

.finance-handle-section .summary-info {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.finance-handle-section .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px dashed #e4e7ed;
}

.finance-handle-section .summary-row:last-child {
  border-bottom: none;
}

.finance-handle-section .summary-label {
  color: #606266;
  width: 100px;
}

.finance-handle-section .summary-value {
  color: #303133;
  flex: 1;
  text-align: right;
  font-weight: 500;
}

.finance-handle-section .finance-form {
  margin-top: 8px;
}

.delivery-handle-section {
  padding: 10px;
}

.delivery-handle-section .summary-info {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.delivery-handle-section .summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px dashed #e4e7ed;
}

.delivery-handle-section .summary-row:last-child {
  border-bottom: none;
}

.delivery-handle-section .summary-label {
  color: #606266;
  width: 100px;
}

.delivery-handle-section .summary-value {
  color: #303133;
  flex: 1;
  text-align: right;
  font-weight: 500;
}

.delivery-handle-section .delivery-form {
  margin-top: 8px;
}

.batch-handle-content {
  padding: 10px;
}

.batch-summary {
  background-color: #f5f7fa;
  padding: 14px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.batch-summary .summary-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  border-bottom: 1px dashed #e4e7ed;
}

.batch-summary .summary-item:last-child {
  border-bottom: none;
}

.batch-summary .summary-label {
  color: #606266;
  width: 80px;
}

.batch-summary .summary-value {
  color: #303133;
  flex: 1;
  text-align: right;
  font-weight: 500;
}

.batch-handle-form {
  margin-top: 8px;
}

.batch-tip {
  color: #909399;
  font-size: 12px;
  margin: 8px 0 16px;
  padding-left: 140px;
}

.audit-tip {
  color: #E6A23C;
  font-size: 12px;
  margin-bottom: 12px;
  padding: 8px 12px;
  background-color: #fdf6ec;
  border-radius: 4px;
}

.dialog-footer {
  text-align: right;
}

.import-content {
  padding: 20px 0;
}

.import-upload-area {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.import-upload .el-button {
  padding: 8px 24px;
}

.download-template {
  color: #409EFF;
  font-size: 13px;
  text-decoration: underline;
}

.download-template:hover {
  color: #66b1ff;
}

.import-tip {
  margin-top: 10px;
}

.tip-text {
  color: #F56C6C;
  font-size: 13px;
}

.non-baozun-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #E6A23C;
  font-size: 13px;
}

.non-baozun-banner i {
  font-size: 16px;
}

.no-batch-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #F56C6C;
  font-size: 13px;
}

.no-batch-banner i {
  font-size: 16px;
}

.no-freight-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #1890ff;
  font-size: 13px;
}

.no-freight-banner i {
  font-size: 16px;
}

.interface-stuck-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #fa8c16;
  font-size: 13px;
}

.interface-stuck-banner i {
  font-size: 16px;
}

.required-asterisk {
  color: #f56c6c;
  margin-right: 4px;
}

.four-col-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.grid-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid-item .label {
  font-size: 13px;
  color: #606266;
}

@media (max-width: 1400px) {
  .four-col-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .four-col-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .four-col-grid {
    grid-template-columns: 1fr;
  }
}
</style>
